import WasmController from "react-lib/frameworks/WasmController";
import * as MainHISI from "./MainHISInterface";
import * as TPDInterface from "react-lib/apps/HISV3/TPD/TPDInterface";
import * as CardPatientQueueI from "react-lib/apps/HISV3/common/CardPatientListInterface";
import * as VitalSignInterface from "react-lib/apps/HISV3/PTM/VitalSignInterface";
import * as CommonInterface from "react-lib/apps/HISV3/common/CommonInterface";
import * as DPIInterface from "react-lib/apps/HISV3/DPI/DPIInterface";
import * as DPOInterface from "react-lib/apps/HISV3/DPO/DPOInterface";
import * as RHBInterface from "react-lib/apps/HISV3/RHB/RHBInterface";
import * as LabInterface from "react-lib/apps/HISV3/LAB/LabInterface";
import * as BILInterface from "react-lib/apps/HISV3/BIL/BILInterface";
import * as ADMInterface from "react-lib/apps/HISV3/ADM/ADMInterface";
import * as IMEInterface from "react-lib/apps/HISV3/IME/IMEInterface";
import * as PTMInterface from "react-lib/apps/HISV3/PTM/PTMInterface";
import * as ORMInterface from "react-lib/apps/HISV3/ORM/ORMInterface";
import * as CLMInterface from "react-lib/apps/HISV3/CLM/CLMInterface";
import * as PHRInterface from "react-lib/apps/HISV3/PHR/PHRInterface";
import * as HCUInterface from "react-lib/apps/HISV3/HCU/HCUInterface";
import * as DentalRecordI from "react-lib/apps/common/CUDENT/DentalRecordInterface";
import * as ANEInterface from "react-lib/apps/HISV3/ANE/ANEInterface";
import * as PHVInterface from "react-lib/apps/HISV3/PHV/PHVInterface";
import * as REGInterface from "react-lib/apps/HISV3/REG/REGInterface";
import * as USERInterface from "react-lib/apps/USER/USERInterface";
import * as HRMInterface from "react-lib/apps/HISV3/HRM/HRMInterface";
import * as WKPInterface from "react-lib/apps/HISV3/WKP/WKPInterface";

import * as StaffChatI from "react-lib/apps/MSG/StaffChatInterface";
import * as QueueForPatientInterface from "react-lib/apps/IsHealth/Dashboard/QueueInterface";

import * as MedAdminI from "react-lib/apps/HISV3/PTM/MedAdminInterface";
import * as IsHealthInterface from "./IsHealth/IsHealthInterface";
import * as VaccineUploadI from "./VaccineUpload/VaccineUploadInterface";
import * as SchedulingI from "react-lib/apps/Scheduling/SchedulingInterface";
import * as SearchBoxI from "react-lib/appcon/common/SearchBoxI";
import * as MSDInterface from "react-lib/apps/HISV3/MSD/MSDInterface";
import * as ADMI from "./Interface/ADMI";
import * as ADRI from "./Interface/ADRI";
import * as ANSI from "./Interface/ANSI";
import * as APPI from "./Interface/APPI";
import * as BILI from "./Interface/BILI";
import * as BLBI from "./Interface/BLBI";
import * as CoreI from "./Interface/CoreI";
import * as DFCI from "./Interface/DFCI";
import * as DPII from "./Interface/DPII";
import * as DPOI from "./Interface/DPOI";
import * as HRMI from "./Interface/HRMI";
import * as ICUI from "./Interface/ICUI";
import * as IMEI from "./Interface/IMEI";
import * as INFI from "./Interface/INFI";
import * as LABI from "./Interface/LABI";
import * as LRMI from "./Interface/LRMI";
import * as MixInI from "./Interface/MixInI";
import * as MSGI from "./Interface/MSGI";
import * as ORMI from "./Interface/ORMI";
import * as PRXI from "./Interface/PRXI";
import * as PTMI from "./Interface/PTMI";
import * as QUEI from "./Interface/QUEI";
import * as REGI from "./Interface/REGI";
import * as TECI from "./Interface/TECI";
import * as TPDI from "./Interface/TPDI";
import * as TRTI from "./Interface/TRTI";
import * as UserI from "./Interface/UserI";
import * as ModPlanningI from "react-lib/apps/HISV3/common/ModPlanningInterface";
import * as ModSolventSelectionI from "react-lib/apps/HISV3/TPD/ModSolventSelectionInterface";
import * as TriageI from "react-lib/apps/HISV3/PTM/sequence/Triage";
import * as SetPatientI from "react-lib/apps/HISV3/REG/sequence/SetPatient";
import * as ReceiveOrderI from "react-lib/apps/HISV3/PTM/sequence/ReceiveOrder";
import * as TreatmentResultI from "react-lib/apps/HISV3/DPO/sequence/TreatmentResult";
import * as DispensingOrderSupplyI from "react-lib/apps/HISV3/MSD/sequence/DispensingOrderSupply";
import * as PerioperativeNursingI from "react-lib/apps/HISV3/ORM/sequence/PerioperativeNursing";
import * as StaffSettingI from "react-lib/apps/USER/StaffSettingInterface";
import * as HealthMemberI from "react-lib/apps/HISV3/PHR/sequence/HealthMember";
// import * as TimeTrackingI from "react-lib/apps/HISV3/DPO/sequence/TimeTracking";

// Ishealth-v3 port into CUDent (vise versa)
import * as PatientSearchCUInterface from "react-lib/apps/common/CU/PatientSearchCUInterface";
import { useIntl } from "react-intl";

export default class MainHISController extends WasmController<
  MainHISI.State,
  MainHISI.Event,
  Partial<MainHISI.Data>,
  MainHISI.Props
> {
  constructor(
    getState: () => MainHISI.State,
    setState:  <K extends keyof MainHISI.State>(
            state: ((prevState: Readonly<MainHISI.State>, props: Readonly<MainHISI.Props>) => Pick<MainHISI.State, K> | MainHISI.State | null) | (Pick<MainHISI.State, K> | MainHISI.State | null),
            callback?: () => void,
        ) => void,
    window: any
  ) {
    super(getState, setState, window, MainHISI.DataInitial);
  }

  handleEvent: (e: MainHISI.Event) => any = (e: MainHISI.Event) => {
    console.groupCollapsed("handleEvent e.message: ", e.message, " e.params: ", (e as any).params);
    console.trace();
    console.groupEnd();
    switch (e.message) {
      case "RunSequence":
        return MainHISI.RunSequence(this as any, e.params);

      case "Logout":
        return CommonInterface.Logout(this as any, e.params);

      case "DidMount":
        return MainHISI.DidMount(this as any, e.params);

      case "DidUpdate":
        return MainHISI.DidUpdate(this as any, e.params);

      case "GetMasterData":
        return CommonInterface.GetMasterData(this as any, e.params);

      // TODO: Duplicate ChangeDivision !!
      case "ChangeDivision":
        return MainHISI.ChangeDivision(this as any, e.params);
      // return SchedulingI.ChangeDivision(this as any, e.params);

      case "ChangeDevice":
        return MainHISI.ChangeDevice(this as any, e.params);

      case "RefreshDivision":
        return MainHISI.RefreshDivision(this as any, e.params);

      case "GetEncounterInfo":
        return MainHISI.GetEncounterInfo(this as any, e.params);

      case "HandleUpdateNotiMessage":
        return MainHISI.HandleUpdateNotiMessage(this as any, e.params);

      case "HandleUpdateBillLockNotiMessage":
        return MainHISI.HandleUpdateBillLockNotiMessage(this as any, e.params);

      case "HandleDidMountEncounter":
        return MainHISI.HandleDidMountEncounter(this as any, e.params);

      case "HandleUnmountEncounter":
        return MainHISI.HandleUnmountEncounter(this as any, e.params);

      case "HandleSelectTabIndex":
        return MainHISI.HandleSelectTabIndex(this as any, e.params);
      case "CheckUserCredentials":
        return MainHISI.CheckUserCredentials(this as any, e.params);
      case "HandleOARequestCheck":
        return MainHISI.HandleOARequestCheck(this as any, e.params);
      case "HandleLoginSuccess":
        return MainHISI.HandleLoginSuccess(this as any, e.params);
      case "HandleCreatedOA":
        return MainHISI.HandleCreatedOA(this as any, e.params);
      // Scheduling
      case "SearchPatient":
        return SchedulingI.SearchPatient(this as any, e.params);

      case "ClearAppointment":
        return SchedulingI.ClearAppointment(this as any, e.params);

      case "SelectPatient":
        return SchedulingI.SelectPatient(this as any, e.params);

      case "CreatePatientAppointment":
        return SchedulingI.CreatePatientAppointment(this as any, e.params);

      case "RefreshAppointment":
        return SchedulingI.RefreshAppointment(this as any, e.params);

      case "SelectAppointment":
        return SchedulingI.SelectAppointment(this as any, e.params);

      case "HandleDownloadAppointmentSummary":
        return SchedulingI.HandleDownloadAppointmentSummary(this as any, e.params);

      case "HandlePrintAppointmentSummaryList":
        return SchedulingI.HandlePrintAppointmentSummaryList(this as any, e.params);

      case "AssignAppointmentToBlock":
        return SchedulingI.AssignAppointmentToBlock(this as any, e.params);

      case "FilterSchedule":
        return SchedulingI.FilterSchedule(this as any, e.params);

      case "FilterAppointmentSchedule":
        return SchedulingI.FilterAppointmentSchedule(this as any, e.params);

      case "GetBlockListFilter":
        return SchedulingI.GetBlockListFilter(this as any, e.params);

      case "AddBlock":
        return SchedulingI.AddBlock(this as any, e.params);

      case "GetChairList":
        return SchedulingI.GetChairList(this as any, e.params);

      case "GetChairWithDivisionServiceBlock":
        return SchedulingI.GetChairWithDivisionServiceBlock(this as any, e.params);

      case "BookChair":
        return SchedulingI.BookChair(this as any, e.params);

      case "SetScheduling":
        return SchedulingI.SetScheduling(this as any, e.params);

      case "GetSummaryWaitingQueue":
        return SchedulingI.GetSummaryWaitingQueue(this as any, e.params);

      case "GetSummaryDoctor":
        return SchedulingI.GetSummaryDoctor(this as any, e.params);

      case "GetSummaryStatistics":
        return SchedulingI.GetSummaryStatistics(this as any, e.params);

      case "UserTokenize":
        return SchedulingI.UserTokenize(this as any, e.params);

      case "GetListSchedule":
        return SchedulingI.GetListSchedule(this as any, e.params);

      case "CreateUpdateSchedule":
        return SchedulingI.CreateUpdateSchedule(this as any, e.params);

      case "Holiday":
        return SchedulingI.Holiday(this as any, e.params);

      case "PrintScheduling":
        return SchedulingI.PrintScheduling(this as any, e.params);

      case "getDoctorNoteList":
        return SchedulingI.getDoctorNoteList(this as any, e.params);

      case "getDoctorNoteGroupList":
        return SchedulingI.getDoctorNoteGroupList(this as any, e.params);

      case "SearchBlockList":
        return SchedulingI.SearchBlockList(this as any, e.params);

      // case "ChangeDivision":
      //   return SchedulingI.ChangeDivision(this as any, e.params);

      case "HandleActionPreOrderList":
        return SchedulingI.HandleActionPreOrderList(this as any, e.params);

      case "ImagingRequestOrder":
        return SchedulingI.ImagingRequestOrder(this as any, e.params);

      case "GetEncounterWithPatient":
        SchedulingI.GetEncounterWithPatient(this as any, e.params);
        return;

      case "HandleSelectAppointmentByOROrder":
        return SchedulingI.HandleSelectAppointmentByOROrder(this as any, e.params);

      case "HandlePrintORAppointmentForm":
        return SchedulingI.HandlePrintORAppointmentForm(this as any, e.params);

      case "CreatePatientAppointmentForBloodBank":
        return SchedulingI.CreatePatientAppointmentForBloodBank(this as any, e.params);

      case "HandleInitialConsultData":
        return SchedulingI.HandleInitialConsultData(this as any, e.params);

      case "HandleSetConsultDetail":
        return SchedulingI.HandleSetConsultDetail(this as any, e.params);

      case "HandleMakeConsultAppointment":
        return SchedulingI.HandleMakeConsultAppointment(this as any, e.params);

      case "HandleConfirmConsultAppointment":
        return SchedulingI.HandleConfirmConsultAppointment(this as any, e.params);

      case "HandleFinishConsultAppointment":
        return SchedulingI.HandleFinishConsultAppointment(this as any, e.params);

      case "HandleSaveConsultResponse":
        return SchedulingI.HandleSaveConsultResponse(this as any, e.params);

      case "HandleEditConsultResponse":
        return SchedulingI.HandleEditConsultResponse(this as any, e.params);

      case "HandleCancelConsultAppointment":
        return SchedulingI.HandleCancelConsultAppointment(this as any, e.params);

      case "HandleGetUsername":
        return SchedulingI.HandleGetUsername(this as any, e.params);

      case "HandlePrintChairBooking":
        return SchedulingI.HandlePrintChairBooking(this as any, e.params);

      case "HandleSaveAppointmentNote":
        return SchedulingI.HandleSaveAppointmentNote(this as any, e.params);
      // Scheduling V3
      // case "SearchPatient":
      //   return SchedulingIV3.SearchPatient(this as any, e.params);

      // case "ClearAppointment":
      //   return SchedulingIV3.ClearAppointment(this as any, e.params);

      // case "SelectPatient":
      //   return SchedulingIV3.SelectPatient(this as any, e.params);

      // case "CreatePatientAppointment":
      //   return SchedulingIV3.CreatePatientAppointment(this as any, e.params);

      // case "SelectAppointment":
      //   return SchedulingIV3.SelectAppointment(this as any, e.params);

      // case "HandleActionPreOrderList":
      //   return SchedulingIV3.HandleActionPreOrderList(this as any, e.params);

      // case "AssignAppointmentToBlock":
      //   return SchedulingIV3.AssignAppointmentToBlock(this as any, e.params);

      // case "FilterSchedule":
      //   return SchedulingIV3.FilterSchedule(this as any, e.params);

      // case "AddBlock":
      //   return SchedulingIV3.AddBlock(this as any, e.params);

      // case "GetChairList":
      //   return SchedulingIV3.GetChairList(this as any, e.params);

      // case "BookChair":
      //   return SchedulingIV3.BookChair(this as any, e.params);

      // case "SetScheduling":
      //   return SchedulingIV3.SetScheduling(this as any, e.params);

      // case "GetListSchedule":
      //   return SchedulingIV3.GetListSchedule(this as any, e.params);

      // case "CreateUpdateSchedule":
      //   return SchedulingIV3.CreateUpdateSchedule(this as any, e.params);

      // case "Holiday":
      //   return SchedulingIV3.Holiday(this as any, e.params);

      // case "ImagingRequestOrder":
      //   SchedulingIV3.ImagingRequestOrder(this as any, e.params);
      //   return;

      // Replaced with SchedulingI
      // case "SearchPatient":
      //   return IsHealthInterface.SearchPatient(this as any, e.params);

      case "SelectPatientForAppointment":
        return IsHealthInterface.SelectPatientForAppointment(this as any, e.params);

      // Replaced with SchedulingI
      // case "CreatePatientAppointment":
      //   return IsHealthInterface.CreatePatientAppointment(this as any, e.params);

      // Replaced with SchedulingI
      // case "SelectAppointment":
      //   return IsHealthInterface.SelectAppointment(this as any, e.params);

      // Replaced with SchedulingI
      // case "AssignAppointmentToBlock":
      //   return IsHealthInterface.AssignAppointmentToBlock(this as any, e.params);

      case "ItemSearch":
        return SearchBoxI.ItemSearch(this as any, e.params as any);

      case "SetDrugOrder":
        return TPDInterface.SetDrugOrder(this as any, e.params);

      case "DrugSearch":
        return TPDInterface.DrugSearch(this as any, e.params);

      case "AddToOrder":
        return TPDInterface.AddToOrder(this as any, e.params);

      case "HandleChangeDrugOrderDetail":
        return TPDInterface.HandleChangeDrugOrderDetail(this as any, e.params);

      // Medication Error List
      case "GetSearchUserList":
        return TPDInterface.GetSearchUserList(this as any, e.params);

      case "GetSearchDivisionList":
        return TPDInterface.GetSearchDivisionList(this as any, e.params);

      case "GetSearchUserDivisionList":
        return TPDInterface.GetSearchUserDivisionList(this as any, e.params);

      case "GetMedicationErrorDetail":
        return TPDInterface.GetMedicationErrorDetail(this as any, e.params);

      case "GetDebugInfo":
        return MainHISI.GetDebugInfo(this as any, e.params);

      case "GetDrugTransferRequestList":
        return TPDInterface.GetDrugTransferRequestList(this as any, e.params);

      case "GetDrugItemDetail":
        return TPDInterface.GetDrugItemDetail(this as any, e.params);

      case "HandleOnRemoveDrug":
        return TPDInterface.HandleOnRemoveDrug(this as any, e.params);
      case "HanleOnLogDrugOrder":
        return TPDInterface.HanleOnLogDrugOrder(this as any, e.params);
      case "HandleGetDrugDetail":
        return TPDInterface.HandleGetDrugDetail(this as any, e.params);

      case "HandleDrugRecommendation":
        return TPDInterface.HandleDrugRecommendation(this as any, e.params);

      case "GetPediatricDose":
        return TPDInterface.GetPediatricDose(this as any, e.params);

      case "HandleChangeEditValueDrug":
        return TPDInterface.HandleChangeEditValueDrug(this as any, e.params);

      case "HandleGetDrugOrderByBarcode":
        return TPDInterface.HandleGetDrugOrderByBarcode(this as any, e.params);
      case "UpdateDrugOrderLocker":
        TPDInterface.UpdateDrugOrderLocker(this as any, e.params);
        return;
      case "GetRejectOrderNotifications":
        return TPDInterface.GetRejectOrderNotifications(this as any, e.params);

      // ModPlanning
      case "handleSetDefaultPlanningData":
        return ModPlanningI.handleSetDefaultPlanningData(this as any);
      case "handleSetPlanningData":
        return ModPlanningI.handleSetPlanningData(this as any, e.params);
      case "handleSetModPlanningConfig":
        return ModPlanningI.handleSetModPlanningConfig(this as any, e.params);
      case "handleEditPlanItem":
        return ModPlanningI.handleEditPlanItem(this as any, e.params);
      case "handleActionPlanItem":
        return ModPlanningI.handleActionPlanItem(this as any, e.params);

      // ModSolventSelection
      case "initModSolventSelection":
        return ModSolventSelectionI.initModSolventSelection(this as any, e.params);
      case "SetModSolventSelectionData":
        return ModSolventSelectionI.SetModSolventSelectionData(this as any, e.params);
      case "SetModSolventSelectionConfig":
        ModSolventSelectionI.SetModSolventSelectionConfig(this as any, e.params);
        return;
      case "GetDrugSolventList":
        return ModSolventSelectionI.GetDrugSolventList(this as any, e.params);
      case "GetDrugSolventDetail":
        return ModSolventSelectionI.GetDrugSolventDetail(this as any, e.params);
      case "SaveSolventOldData":
        return ModSolventSelectionI.SaveSolventOldData(this as any);
      case "SaveSolventData":
        return ModSolventSelectionI.SaveSolventData(this as any, e.params);
      case "RemoveSolventData":
        return ModSolventSelectionI.RemoveSolventData(this as any);

      // TPDInterface
      case "PreviewDrugContinuePlan":
        return TPDInterface.PreviewDrugContinuePlan(this as any, e.params);

      case "ClaimDrugContinuePlan":
        return TPDInterface.ClaimDrugContinuePlan(this as any, e.params);

      case "CheckDrugGroupDuplicate":
        return TPDInterface.CheckDrugGroupDuplicate(this as any, e.params);

      case "ConfirmDrugContinueOrder":
        return TPDInterface.ConfirmDrugContinueOrder(this as any, e.params);

      case "EditDrugContinuePlan":
        return TPDInterface.EditDrugContinuePlan(this as any, e.params);

      case "NoteAndVerifyAndCancelDrugContinuePlan":
        return TPDInterface.NoteAndVerifyAndCancelDrugContinuePlan(this as any, e.params);

      case "ListDrugContinueActionLog":
        return TPDInterface.ListDrugContinueActionLog(this as any, e.params);

      case "SetDrugContinueOptions":
        return TPDInterface.SetDrugContinueOptions(this as any, e.params);

      case "SetModNoteData":
        return TPDInterface.SetModNoteData(this as any, e.params);

      case "SetModSpecialDirectionConfig":
        return TPDInterface.SetModSpecialDirectionConfig(this as any, e.params);

      case "CheckShowButtonSolvent":
        return TPDInterface.CheckShowButtonSolvent(this as any);

      case "ConfirmDrugOrder":
        return TPDInterface.ConfirmDrugOrder(this as any, e.params);

      case "DrugOrderHistory":
        return TPDInterface.DrugOrderHistory(this as any, e.params);

      case "SetDrugOrderItemsData":
        return TPDInterface.SetDrugOrderItemsData(this as any, e.params);

      case "OpenMedReconcileFromWarning":
        return TPDInterface.OpenMedReconcileFromWarning(this as any, e.params);

      case "ClearMedReconcile":
        return TPDInterface.ClearMedReconcile(this as any, e.params);

      case "GetMedReconcile":
        return TPDInterface.GetMedReconcile(this as any, e.params);

      case "GetMedReconcileInternal":
        TPDInterface.GetMedReconcileInternal(this as any, e.params);
        return;

      case "GetMedReconcileLog":
        return TPDInterface.GetMedReconcileLog(this as any, e.params);

      case "GetMedReconcileCheck":
        return TPDInterface.GetMedReconcileCheck(this as any, e.params);

      case "HandleCheckAndGetMedReconcile":
        return TPDInterface.HandleCheckAndGetMedReconcile(this as any, e.params);

      case "ApproveDrugOrder":
        return TPDInterface.ApproveDrugOrder(this as any, e.params);

      case "SetMedReconcile":
        return TPDInterface.SetMedReconcile(this as any, e.params);

      case "HandleGetDetailForExternalDrug":
        return TPDInterface.HandleGetDetailForExternalDrug(this as any, e.params);

      case "MedReconcileDrugOrder":
        TPDInterface.MedReconcileDrugOrder(this as any, e.params);
        return;

      case "GetDrugDetailByNameOrId":
        return TPDInterface.GetDrugDetailByNameOrId(this as any, e.params);

      case "GetClassify":
        return CardPatientQueueI.GetClassify(this as any, e.params);

      case "GetPatientQueue":
        return CardPatientQueueI.GetPatientQueue(this as any, e.params);

      case "GetPatientDetailView":
        return CardPatientQueueI.GetPatientDetailView(this as any, e.params);

      case "SelectEncounter":
        return CardPatientQueueI.SelectEncounter(this as any, e.params);

      case "HandleSaveMedicalRecordDischarge":
        return CardPatientQueueI.HandleSaveMedicalRecordDischarge(this as any, e.params);
      case "DrugOrderUpdateCallTelephar":
        return CardPatientQueueI.DrugOrderUpdateCallTelephar(this as any, e.params);

      case "UpdateEncounterStatus":
        return CardPatientQueueI.UpdateEncounterStatus(this as any, e.params);

      case "HandleCheckApprove":
        return CardPatientQueueI.HandleCheckApprove(this as any, e.params);

      case "HandleRefreshEncounter":
        return CardPatientQueueI.HandleRefreshEncounter(this as any, e.params);

      case "HandleDischargeConsult":
        return CardPatientQueueI.HandleDischargeConsult(this as any, e.params);

      case "HandleAddMessageProblemDPO":
        return CardPatientQueueI.HandleAddMessageProblemDPO(this as any, e.params);

      case "GetUsernameForDischarge":
        return CardPatientQueueI.GetUsernameForDischarge(this as any, e.params);

      case "GetDoctorSearch":
        return CardPatientQueueI.GetDoctorSearch(this as any, e.params);

      case "GetDivisionByOrganization":
        return CardPatientQueueI.GetDivisionByOrganization(this as any, e.params);

      case "CheckUserLogin":
        return CardPatientQueueI.CheckUserLogin(this as any, e.params);

      case "CUCheckUserLogin":
        return CardPatientQueueI.CUCheckUserLogin(this as any, e.params);

      case "HandleGetDoctorOrder":
        return CardPatientQueueI.HandleGetDoctorOrder(this as any, e.params);

      case "HandleGoToCreateAppointment":
        return CardPatientQueueI.HandleGoToCreateAppointment(this as any, e.params);

      case "HandleGoBackEncounter":
        return CardPatientQueueI.HandleGoBackEncounter(this as any, e.params);

      case "HandleGoBackAppointment":
        return CardPatientQueueI.HandleGoBackAppointment(this as any, e.params);

      case "SetMedHistory":
        return CardPatientQueueI.SetMedHistory(this as any, e.params);

      case "GetDrugOrderList":
        return TPDInterface.GetDrugOrderList(this as any, e.params);

      case "RefreshDrugOrderList":
        return TPDInterface.RefreshDrugOrderList(this as any, e.params);

      case "GetDrugOrderType":
        return TPDInterface.GetDrugOrderType(this as any, e.params);

      case "GetDrugOrderDefaultTab":
        return TPDInterface.GetDrugOrderDefaultTab(this as any, e.params);

      case "GetDrugPriorityOptions":
        return TPDInterface.GetDrugPriorityOptions(this as any, e.params);

      case "ClearDrugOperatingOrderList":
        return TPDInterface.ClearDrugOperatingOrderList(this as any, e.params);

      case "GetDrugOrderQueue":
        return TPDInterface.GetDrugOrderQueue(this as any, e.params);

      case "SaveDrugPendingRemark":
        return TPDInterface.SaveDrugPendingRemark(this as any, e.params);

      case "GetDrugContinuePlan":
        return TPDInterface.GetDrugContinuePlan(this as any);

      case "SetDrugContinuePlan":
        return TPDInterface.SetDrugContinuePlan(this as any, e.params);

      case "SetDrugContinueFilter":
        return TPDInterface.SetDrugContinueFilter(this as any, e.params);

      case "SelectDrugOrderWorking":
        return TPDInterface.SelectDrugOrderWorking(this as any, e.params);

      case "SelectDashboardTelephar":
        return TPDInterface.SelectDashboardTelephar(this as any, e.params);

      case "SelectTelepharQueue":
        return TPDInterface.SelectTelepharQueue(this as any, e.params);

      case "SelectVerbalDrugOrderWorking":
        return TPDInterface.SelectVerbalDrugOrderWorking(this as any, e.params);

      case "HandleSavePostponeAnswer":
        TPDInterface.HandleSavePostponeAnswer(this as any, e.params);
        return;

      case "PutDrugOrderItemPrintLabel":
        TPDInterface.PutDrugOrderItemPrintLabel(this as any, e.params);
        return;

      case "HandleCloseDrugOrderEstimate":
        TPDInterface.HandleCloseDrugOrderEstimate(this as any, e.params);
        return;

      case "CheckHaveQuestion":
        TPDInterface.CheckHaveQuestion(this as any, e.params);
        return;

      case "HandleSetAnswerDrugOrderItem":
        TPDInterface.HandleSetAnswerDrugOrderItem(this as any, e.params);
        return;

      case "DeleteDrugOrderItem":
        TPDInterface.DeleteDrugOrderItem(this as any, e.params);
        return;

      case "HandleCheckDoctorCertificate":
        return TPDInterface.HandleCheckDoctorCertificate(this as any, e.params);

      case "HandleGetDeliverDrugTokenization":
        TPDInterface.HandleGetDeliverDrugTokenization(this as any, e.params);
        return;

      case "HandleReMedication":
        TPDInterface.HandleReMedication(this as any, e.params);
        return;

      case "HandleModRecontinueMedication":
        TPDInterface.HandleModRecontinueMedication(this as any, e.params);
        return;

      case "CreateDrugOrderItemClaim":
        TPDInterface.CreateDrugOrderItemClaim(this as any, e.params);
        return;

      case "UpdateDrugOrderWorking":
        TPDInterface.UpdateDrugOrderWorking(this as any, e.params);
        return;

      case "PrintDrugOrderFromDoctor":
        TPDInterface.PrintDrugOrderFromDoctor(this as any, e.params);
        return;

      case "HandlePrintNarcoticForm":
        TPDInterface.HandlePrintNarcoticForm(this as any, e.params);
        return;

      case "HandlePrintPsychotropicForm":
        TPDInterface.HandlePrintPsychotropicForm(this as any, e.params);
        return;

      case "HandleNurseOrderPerformed":
        TPDInterface.HandleNurseOrderPerformed(this as any, e.params);
        return;

      case "HandleModDrugLabInteraction":
        TPDInterface.HandleModDrugLabInteraction(this as any, e.params);
        return;

      case "HandleModDrugDisease":
        TPDInterface.HandleModDrugDisease(this as any, e.params);
        return;

      case "HandleModDrugInteraction":
        TPDInterface.HandleModDrugInteraction(this as any, e.params);
        return;

      case "AllVerifyDrug":
        return TPDInterface.AllVerifyDrug(this as any, e.params);

      case "DrugPackageAddToOrder":
        return TPDInterface.DrugPackageAddToOrder(this as any, e.params);

      case "GetLotNoExp":
        return TPDInterface.GetLotNoExp(this as any, e.params);

      case "UpdateLotNoExp":
        TPDInterface.UpdateLotNoExp(this as any, e.params);
        return;

      case "GetVitalSignType":
        return VitalSignInterface.GetVitalSignType(this as any, e.params);

      case "GetVitalSign":
        return VitalSignInterface.GetVitalSign(this as any, e.params);

      case "GetLastHeight":
        return VitalSignInterface.GetLastHeight(this as any, e.params);

      case "GetIPDOrderSummary":
        return DPIInterface.GetIPDOrderSummary(this as any, e.params);

      case "SetIPDOrderSummaryFirebase":
        return DPIInterface.SetIPDOrderSummaryFirebase(this as any, e.params);

      case "GetIPDContinueHistory":
        return DPIInterface.GetIPDContinueHistory(this as any, e.params);

      case "GetDrugOrderListDpi":
        return DPIInterface.GetDrugOrderListDpi(this as any, e.params);

      case "HandleSetContinueHistoryList":
        return DPIInterface.HandleSetContinueHistoryList(this as any, e.params);

      case "GetUserPermissionOrderSummary":
        return DPIInterface.GetUserPermissionOrderSummary(this as any, e.params);

      case "HandleUpdatePlanItem":
        return DPIInterface.HandleUpdatePlanItem(this as any, e.params);

      case "HandleDeleteFoodOrder":
        return DPIInterface.HandleDeleteFoodOrder(this as any, e.params);

      case "HandleSetOpenModSuccessOrderSummary":
        return DPIInterface.HandleSetOpenModSuccessOrderSummary(this as any, e.params);

      case "HandleSetFilterOrderSummary":
        return DPIInterface.HandleSetFilterOrderSummary(this as any, e.params);

      case "UpdateDoctorOrderCancel":
        return DPIInterface.UpdateDoctorOrderCancel(this as any, e.params);

      case "GetListProgressionNote":
        DPIInterface.GetListProgressionNote(this as any, e.params);
        return;

      case "SaveNewMeasurement":
        return VitalSignInterface.SaveNewMeasurement(this as any, e.params);

      case "AddVitalSignValue":
        return VitalSignInterface.AddVitalSignValue(this as any, e.params);

      case "CancelMeasurement":
        return VitalSignInterface.CancelMeasurement(this as any, e.params);

      case "getAdverseReactionList":
        return DPOInterface.getAdverseReactionList(this as any, e.params);

      case "postAdverseReaction":
        return DPOInterface.postAdverseReaction(this as any, e.params);

      case "postPatientScreenNew":
        return DPOInterface.postPatientScreenNew(this as any, e.params);

      case "getMedicalRecordEmrDetail":
        return DPOInterface.getMedicalRecordEmrDetail(this as any, e.params);

      case "getEncounterDetail":
        return DPOInterface.getEncounterDetail(this as any, e.params);

      case "putPatientScreenUpdate":
        return DPOInterface.putPatientScreenUpdate(this as any, e.params);

      case "putAdverseReaction":
        return DPOInterface.putAdverseReaction(this as any, e.params);

      case "getPhysicalExamOrgan":
        return DPOInterface.getPhysicalExamOrgan(this as any, e.params);

      case "HandleGetTreatmentTokenization":
        return TreatmentResultI.HandleGetTreatmentTokenization(this as any, e.params);

      case "GetProblemList":
        return CardPatientQueueI.GetProblemList(this as any, e.params);

      case "GetLabCode":
        return LabInterface.GetLabCode(this as any, e.params);

      case "GetLabDetail":
        return LabInterface.GetLabDetail(this as any, e.params);

      case "GetLabInterfaceSummary":
        return LabInterface.GetLabInterfaceSummary(this as any, e.params);

      case "GetDoctorLabOrderList":
        return LabInterface.GetDoctorLabOrderList(this as any, e.params);

      case "GetCentralLabOrder":
        return LabInterface.GetCentralLabOrder(this as any, e.params);

      case "CheckPermissionLabConfidential":
        return LabInterface.CheckPermissionLabConfidential(this as any, e.params);

      case "SetLabOrderQueueData":
        return LabInterface.SetLabOrderQueueData(this as any, e.params);

      // ------------------------------ CardSpecimenCollector
      case "SpecimenCollectorMasterData":
        return LabInterface.SpecimenCollectorMasterData(this as any, e.params);
      case "SpecimenLogList":
        return LabInterface.SpecimenLogList(this as any, e.params);
      case "PrintLabSticker":
        return LabInterface.PrintLabSticker(this as any, e.params);
      case "ReceiveSpecimen":
        return LabInterface.ReceiveSpecimen(this as any, e.params);
      case "RejectSpecimen":
        return LabInterface.RejectSpecimen(this as any, e.params);
      case "EndCollectSpecimen":
        return LabInterface.EndCollectSpecimen(this as any, e.params);
      case "CancelCollectSpecimen":
        return LabInterface.CancelCollectSpecimen(this as any, e.params);
      case "ScanBarcodeStickerSpecimen":
        return LabInterface.ScanBarcodeStickerSpecimen(this as any, e.params);
      case "HandlePrintStickerSpecimen":
        return LabInterface.HandlePrintStickerSpecimen(this as any, e.params);
      //
      case "CentralLabResultList":
        return LabInterface.CentralLabResultList(this as any, e.params);
      case "ListCentralLabResultConfidential":
        return LabInterface.ListCentralLabResultConfidential(this as any, e.params);

      case "GetLabOrderQueue":
        return LabInterface.GetLabOrderQueue(this as any, e.params);

      case "SelectLabOrderWorking":
        return LabInterface.SelectLabOrderWorking(this as any, e.params);

      case "SaveLabResult":
        return LabInterface.SaveLabResult(this as any, e.params);

      case "AuthorizeLabResult":
        return LabInterface.AuthorizeLabResult(this as any, e.params);

      case "LabOrderArrive":
        return LabInterface.LabOrderArrive(this as any, e.params);

      case "HandlePrintLabSummary":
        return LabInterface.HandlePrintLabSummary(this as any, e.params);

      case "GetAppointmentOrderDoctor":
        return LabInterface.GetAppointmentOrderDoctor(this as any, e.params);

      case "HandlePrintLabResult":
        return LabInterface.HandlePrintLabResult(this as any, e.params);

      case "ClearDrugOrderForm":
        return TPDInterface.ClearDrugOrderForm(this as any, e.params);

      case "HandleCheckDrugOrderError":
        return TPDInterface.HandleCheckDrugOrderError(this as any, e.params);

      case "GetInvoiceItemByMode":
        return BILInterface.GetInvoiceItemByMode(this as any, e.params);

      case "GetInvoiceItemByOrder":
        return BILInterface.GetInvoiceItemByOrder(this as any, e.params);

      case "GetInvoiceItemByItem":
        return BILInterface.GetInvoiceItemByItem(this as any, e.params);

      case "HandleSearchInvoiceItems":
        return BILInterface.HandleSearchInvoiceItems(this as any, e.params);

      case "GetMasterDataPayMethod":
        return BILInterface.GetMasterDataPayMethod(this as any, e.params);

      case "HandleSetPaymentMethodList":
        return BILInterface.HandleSetPaymentMethodList(this as any, e.params);

      case "HandleChangePaymentMethodList":
        return BILInterface.HandleChangePaymentMethodList(this as any, e.params);

      case "HandleKeyDownCouponNumber":
        return BILInterface.HandleKeyDownCouponNumber(this as any, e.params);

      case "GetReportStationSummary":
        BILInterface.GetReportStationSummary(this as any, e.params);
        return;

      case "GetReceiptPoolData":
        BILInterface.GetReceiptPoolData(this as any, e.params);
        return;

      case "EditReceiptPool":
        BILInterface.EditReceiptPool(this as any, e.params);
        return;

      case "UpdateEncounterLocker":
        BILInterface.UpdateEncounterLocker(this as any, e.params);
        return;

      case "CheckEncounterLocker":
        return BILInterface.CheckEncounterLocker(this as any, e.params);

      case "HandleInitMedicalFeeFilter":
        return BILInterface.HandleInitMedicalFeeFilter(this as any, e.params);

      case "UpdateReportStationSummary":
        BILInterface.UpdateReportStationSummary(this as any, e.params);
        return;

      case "BillingQueueAction":
        return BILInterface.BillingQueueAction(this as any, e.params);

      case "GetPatientDoctorOrder":
        return BILInterface.GetPatientDoctorOrder(this as any, e.params);

      case "BillingQueuePagination":
        return BILInterface.BillingQueuePagination(this as any, e.params);

      case "GetCreditNoteItem":
        return BILInterface.GetCreditNoteItem(this as any, e.params);

      case "HandleTransfer":
        return BILInterface.HandleTransfer(this as any, e.params);

      case "HandleGetEncounterSuspension":
        return BILInterface.HandleGetEncounterSuspension(this as any, e.params);

      case "HandleUpdateEncounterSuspension":
        return BILInterface.HandleUpdateEncounterSuspension(this as any, e.params);

      case "HandleRefreshTaskTracking":
        return BILInterface.HandleRefreshTaskTracking(this as any, e.params);

      case "HandlePostReceiptCode":
        return BILInterface.HandlePostReceiptCode(this as any, e.params);

      case "HandleGetReceiptCode":
        return BILInterface.HandleGetReceiptCode(this as any, e.params);

      case "GetBillPendingDetail":
        return BILInterface.GetBillPendingDetail(this as any, e.params);

      case "GetPatientEncounterLockerStatus":
        return BILInterface.GetPatientEncounterLockerStatus(this as any, e.params);

      case "GetCommonBillTransaction":
        return BILInterface.GetCommonBillTransaction(this as any, e.params);

      case "HandlePrintMedicalFeeDetail":
        return BILInterface.HandlePrintMedicalFeeDetail(this as any, e.params);

      case "HandleReportPrintTrackingResult":
        return BILInterface.HandleReportPrintTrackingResult(this as any, e.params);

      case "GetFexClaimDetail":
        return BILInterface.GetFexClaimDetail(this as any, e.params);

      case "HandleUpdateFexClaim":
        return BILInterface.HandleUpdateFexClaim(this as any, e.params);

      case "GetInvoiceItemPackageApply":
        return BILInterface.GetInvoiceItemPackageApply(this as any, e.params);

      case "CreateInvoiceItemPackageApply":
        return BILInterface.CreateInvoiceItemPackageApply(this as any, e.params);

      case "GetPatientLanguage":
        return BILInterface.GetPatientLanguage(this as any, e.params);

      case "GetPatientCoverageList":
        return BILInterface.GetPatientCoverageList(this as any, e.params);

      case "GetBillingLockNotifications":
        return BILInterface.GetBillingLockNotifications(this as any, e.params);

      case "HandleDeleteInvoiceItem":
        return BILInterface.HandleDeleteInvoiceItem(this as any, e.params);

      case "GetBillingEncounterOrder":
        return BILInterface.GetBillingEncounterOrder(this as any, e.params);
      // ----- CLM Interface
      case "GetARTransactions":
        return CLMInterface.GetARTransactions(this as any, e.params);
      case "GetEncounterList":
        return CLMInterface.GetEncounterList(this as any, e.params);
      case "HandleUploadPatientCoverage":
        return CLMInterface.HandleUploadPatientCoverage(this as any, e.params);
      // ----- HCU Interface
      case "HandleGetPurchaseOrderList":
        return HCUInterface.HandleGetPurchaseOrderList(this as any, e.params);
      // ----- PHR Interface
      // Med Admin
      case "MedAdminMainComponentDidMount":
        return MedAdminI.MedAdminMainComponentDidMount(this as any, e.params);
      case "MedAdminGetMedicationRecordSummary":
        return MedAdminI.MedAdminGetMedicationRecordSummary(this as any, e.params);
      case "MedAdminGetListMedAdminRecord":
        return MedAdminI.MedAdminGetListMedAdminRecord(this as any, e.params);
      case "MedAdminGetPatientByHN":
        return MedAdminI.MedAdminGetPatientByHN(this as any, e.params);
      case "MedAdminGetClinicalTermSet":
        return MedAdminI.MedAdminGetClinicalTermSet(this as any, e.params);
      case "MedAdminGetUserPermission":
        return MedAdminI.MedAdminGetUserPermission(this as any, e.params);
      case "MedAdminGetUserTokenize":
        return MedAdminI.MedAdminGetUserTokenize(this as any, e.params);
      case "MedAdminPostCreateMedAdminRecord":
        return MedAdminI.MedAdminPostCreateMedAdminRecord(this as any, e.params);
      case "MedAdminPutUpdateMedAdminRecord":
        return MedAdminI.MedAdminPutUpdateMedAdminRecord(this as any, e.params);
      case "MedAdminGetPrescriptionSite":
        return MedAdminI.MedAdminGetPrescriptionSite(this as any);
      case "MedAdminPutMedAdminRecord":
        return MedAdminI.MedAdminPutMedAdminRecord(this as any, e.params);
      case "MedAdminPutDrugOrderItemIdAddStdTimeManual":
        return MedAdminI.MedAdminPutDrugOrderItemIdAddStdTimeManual(this as any, e.params);
      case "MedAdminPutDrugOrderItemIdEditStdTimeManual":
        return MedAdminI.MedAdminPutDrugOrderItemIdEditStdTimeManual(this as any, e.params);
      case "MedAdminPutDrugOrderItemIdAdminDivision":
        return MedAdminI.MedAdminPutDrugOrderItemIdAdminDivision(this as any, e.params);
      case "MedAdminPostMedAdminRecord":
        return MedAdminI.MedAdminPostMedAdminRecord(this as any, e.params);
      case "MedAdminGetPrintMedRecord":
        return MedAdminI.MedAdminGetPrintMedRecord(this as any, e.params);
      case "MedAdminGetPatientInfo":
        return MedAdminI.MedAdminGetPatientInfo(this as any, e.params);
      // ADM
      case "GetListOrderDivision":
        return ADMInterface.GetListOrderDivision(this as any, e.params);

      case "GetListRoom":
        return ADMInterface.GetListRoom(this as any, e.params);

      case "PrintReportAdmitOrder":
        return ADMInterface.PrintReportAdmitOrder(this as any, e.params);

      case "GetListAdmitOrder":
        return ADMInterface.GetListAdmitOrder(this as any, e.params);

      case "PrintReportPostponeAdmitOrder":
        return ADMInterface.PrintReportPostponeAdmitOrder(this as any, e.params);

      case "HandleConsultListToWard":
        return ADMInterface.HandleConsultListToWard(this as any, e.params);

      // IMEInterface
      case "ListImagingResult":
        return IMEInterface.ListImagingResult(this as any, e.params);
      case "OpenPACS":
        return IMEInterface.OpenPACS(this as any, e.params);

      // VaccineUploadI
      case "GetVaccineInfo":
        return VaccineUploadI.GetVaccineInfo(this as any, e.params);

      case "ChooseVaccineFile":
        return VaccineUploadI.ChooseVaccineFile(this as any, e.params);

      case "UploadVaccineData":
        return VaccineUploadI.UploadData(this as any, e.params);

      case "GetVaccineDataList":
        return VaccineUploadI.GetDataList(this as any, e.params);

      case "GenerateVaccineUser":
        return VaccineUploadI.GenerateUser(this as any, e.params);

      case "CloseGenerateVaccineUserModal":
        return VaccineUploadI.CloseGenerateUserModal(this as any, e.params);

      case "HandleSelectAdmitEncounter":
        ADMInterface.HandleSelectAdmitEncounter(this as any, e.params);
        return;

      case "HandleNurseNote":
        PTMInterface.HandleNurseNote(this as any, e.params);
        return;

      case "handleNurseNoteReport":
        PTMInterface.handleNurseNoteReport(this as any, e.params);
        return;

      case "HandleGetVerbalHistory":
        PTMInterface.HandleGetVerbalHistory(this as any, e.params);
        return;

      case "HandleVerbalOrderAction":
        PTMInterface.HandleVerbalOrderAction(this as any, e.params);
        return;

      case "SaveVerbalOrder":
        return PTMInterface.SaveVerbalOrder(this as any, e.params);

      case "HandleOPDOrderSummary":
        PTMInterface.HandleOPDOrderSummary(this as any, e.params);
        return;

      case "HandleEditOPDOrderSummary":
        PTMInterface.HandleEditOPDOrderSummary(this as any, e.params);
        return;

      case "HandleDeleteOPDOrderSummary":
        PTMInterface.HandleDeleteOPDOrderSummary(this as any, e.params);
        return;

      case "handleGetEncounterVitalSignList":
        PTMInterface.handleGetEncounterVitalSignList(this as any, e.params);
        return;
      case "HandleGetDeliverSupplyTokenization":
        DispensingOrderSupplyI.HandleGetDeliverSupplyTokenization(this as any, e.params);
        return;

      case "HandleGetORPostOperativeTokenization":
        PerioperativeNursingI.HandleGetORPostOperativeTokenization(this as any, e.params);
        return;

      case "GetChatChannelList":
        StaffChatI.GetChatChannelList(this as any, e.params);
        return;
      case "GetUnreadMessageCountStaff":
        StaffChatI.GetUnreadMessageCountStaff(this as any, e.params);
        return;
      case "GetUserChatSubscriptionList":
        StaffChatI.GetUserChatSubscriptionList(this as any, e.params);
        return;
      case "GetSearchMessageList":
        StaffChatI.GetSearchMessageList(this as any, e.params);
        return;

      case "CreateUpdateChatRoom":
        return StaffChatI.CreateUpdateChatRoom(this as any, e.params);
      // Auto gen from this point onward =====================================
      case "getWardType":
        return ADMI.getWardType(this as any, e.params);

      case "getRoomType":
        return ADMI.getRoomType(this as any, e.params);

      case "getAdmitStatusChoice":
        return ADMI.getAdmitStatusChoice(this as any, e.params);

      case "getAdmitOrder":
        return ADMI.getAdmitOrder(this as any, e.params);

      case "getAdmitOrderDetail":
        return ADMI.getAdmitOrderDetail(this as any, e.params);

      case "estimateAdmit":
        return ADMI.estimateAdmit(this as any, e.params);

      case "createAdmitOrder":
        return ADMI.createAdmitOrder(this as any, e.params);

      case "updateAdmitOrder":
        return ADMI.updateAdmitOrder(this as any, e.params);

      case "printReservation":
        return ADMI.printReservation(this as any, e.params);

      case "getAdmitDay":
        return ADMI.getAdmitDay(this as any, e.params);

      case "getAdmitOrderRoomItemStatus":
        return ADMI.getAdmitOrderRoomItemStatus(this as any, e.params);

      case "putAdmitOrderRoomItem":
        return ADMI.putAdmitOrderRoomItem(this as any, e.params);

      case "admService":
        return ADMI.admService(this as any, e.params);

      case "getAdverseReaction":
        return ADRI.getAdverseReaction(this as any, e.params);

      // case "getAdverseReactionList":
      //   return ADRI.getAdverseReactionList(this as any, e.params);

      // case "postAdverseReaction":
      //   return ADRI.postAdverseReaction(this as any, e.params);

      // case "putAdverseReaction":
      //   return ADRI.putAdverseReaction(this as any, e.params);

      case "getAnesthesiaQueue":
        return ANSI.getAnesthesiaQueue(this as any, e.params);

      case "getAnesthesiaQueueZoneChoice":
        return ANSI.getAnesthesiaQueueZoneChoice(this as any, e.params);

      case "getAnesthesiaOrderWithId":
        return ANSI.getAnesthesiaOrderWithId(this as any, e.params);

      case "getAnesthesiaConsultWithId":
        return ANSI.getAnesthesiaConsultWithId(this as any, e.params);

      case "putAnesthesiaOrderAction":
        return ANSI.putAnesthesiaOrderAction(this as any, e.params);

      case "putAnesthesiaConsultAction":
        return ANSI.putAnesthesiaConsultAction(this as any, e.params);

      case "getInvestigationResult":
        return ANSI.getInvestigationResult(this as any, e.params);

      case "getAnesthesiaData":
        return ANSI.getAnesthesiaData(this as any, e.params);

      case "getPreAnestheticAnesthesiaRecord":
        return ANSI.getPreAnestheticAnesthesiaRecord(this as any, e.params);

      case "getPreAnestheticAnesthesiaLog":
        return ANSI.getPreAnestheticAnesthesiaLog(this as any, e.params);

      case "printFormAns":
        return ANSI.printFormAns(this as any, e.params);

      case "postPreAnestheticAnesthesiaRecord":
        return ANSI.postPreAnestheticAnesthesiaRecord(this as any, e.params);

      case "putPreAnestheticAnesthesiaRecord":
        return ANSI.putPreAnestheticAnesthesiaRecord(this as any, e.params);

      case "getAnesthesiaGraph":
        return ANSI.getAnesthesiaGraph(this as any, e.params);

      case "getAgentTemplate":
        return ANSI.getAgentTemplate(this as any, e.params);

      case "getAgentByRecord":
        return ANSI.getAgentByRecord(this as any, e.params);

      case "getAgentItem":
        return ANSI.getAgentItem(this as any, e.params);

      case "putAgentItem":
        return ANSI.putAgentItem(this as any, e.params);

      case "postAnesthesiaAgent":
        return ANSI.postAnesthesiaAgent(this as any, e.params);

      case "getAnesthesiaEventMedication":
        return ANSI.getAnesthesiaEventMedication(this as any, e.params);

      case "getEventMedicationByRecord":
        return ANSI.getEventMedicationByRecord(this as any, e.params);

      case "postAnesthesiaEventMedication":
        return ANSI.postAnesthesiaEventMedication(this as any, e.params);

      case "putAnesthesiaEventMedication":
        return ANSI.putAnesthesiaEventMedication(this as any, e.params);

      case "getMonitorTemplate":
        return ANSI.getMonitorTemplate(this as any, e.params);

      case "getMonitorByRecord":
        return ANSI.getMonitorByRecord(this as any, e.params);

      case "getMonitorItem":
        return ANSI.getMonitorItem(this as any, e.params);

      case "putMonitorItem":
        return ANSI.putMonitorItem(this as any, e.params);

      case "postAnesthesiaMonitor":
        return ANSI.postAnesthesiaMonitor(this as any, e.params);

      case "getIntakeOutputTemplate":
        return ANSI.getIntakeOutputTemplate(this as any, e.params);

      case "getIntakeByRecord":
        return ANSI.getIntakeByRecord(this as any, e.params);

      case "postAnesthesiaIntake":
        return ANSI.postAnesthesiaIntake(this as any, e.params);

      case "getIntakeItem":
        return ANSI.getIntakeItem(this as any, e.params);

      case "putIntakeItem":
        return ANSI.putIntakeItem(this as any, e.params);

      case "getOutputByRecord":
        return ANSI.getOutputByRecord(this as any, e.params);

      case "postAnesthesiaOutput":
        return ANSI.postAnesthesiaOutput(this as any, e.params);

      case "getOutputItem":
        return ANSI.getOutputItem(this as any, e.params);

      case "putOutputItem":
        return ANSI.putOutputItem(this as any, e.params);

      case "getAnesthesiaBillWithId":
        return ANSI.getAnesthesiaBillWithId(this as any, e.params);

      case "getAnesthesiaTemplateList":
        return ANSI.getAnesthesiaTemplateList(this as any, e.params);

      case "getAnesthesiaTemplateWithId":
        return ANSI.getAnesthesiaTemplateWithId(this as any, e.params);

      case "getAnesthesiaBillLog":
        return ANSI.getAnesthesiaBillLog(this as any, e.params);

      case "printAnesthesiaBill":
        return ANSI.printAnesthesiaBill(this as any, e.params);

      case "postAnesthesiaBill":
        return ANSI.postAnesthesiaBill(this as any, e.params);

      case "putAnesthesiaBill":
        return ANSI.putAnesthesiaBill(this as any, e.params);

      case "getAppointmentWithId":
        return APPI.getAppointmentWithId(this as any, e.params);

      case "deleteAppointmentWithId":
        return APPI.deleteAppointmentWithId(this as any, e.params);

      case "cancelAppointment":
        return APPI.cancelAppointment(this as any, e.params);

      case "updateAppointmentWithId":
        return APPI.updateAppointmentWithId(this as any, e.params);

      case "postponeAppointmentWithId":
        return APPI.postponeAppointmentWithId(this as any, e.params);

      case "getDoctorWorkAtDivision":
        return APPI.getDoctorWorkAtDivision(this as any, e.params);

      case "convertDoctorScheduleToChoice":
        return APPI.convertDoctorScheduleToChoice(this as any, e.params);

      case "getAppointmentOrder":
        return APPI.getAppointmentOrder(this as any, e.params);

      case "getAppointmentOrderRaw":
        return APPI.getAppointmentOrderRaw(this as any, e.params);

      case "getDoctorNote":
        return APPI.getDoctorNote(this as any, e.params);

      case "getDoctorNoteGroup":
        return APPI.getDoctorNoteGroup(this as any, e.params);

      case "getDoctorScheduleAppointment":
        return APPI.getDoctorScheduleAppointment(this as any, e.params);

      case "postAppointmentRequest":
        return APPI.postAppointmentRequest(this as any, e.params);

      case "printAppointment":
        return APPI.printAppointment(this as any, e.params);

      case "_convertToAppointmentModel":
        return APPI._convertToAppointmentModel(this as any, e.params);

      case "getQueueList":
        return BILI.getQueueList(this as any, e.params);

      case "getInvoice":
        return BILI.getInvoice(this as any, e.params);

      case "getInvoiceDetail":
        return BILI.getInvoiceDetail(this as any, e.params);

      case "postInvoice":
        return BILI.postInvoice(this as any, e.params);

      case "getInvoiceItemByItem":
        return BILI.getInvoiceItemByItem(this as any, e.params);

      case "postPaymentParameters":
        return BILI.postPaymentParameters(this as any, e.params);

      case "getReceipt":
        return BILI.getReceipt(this as any, e.params);

      case "getBloodGroupWithPatient":
        return BLBI.getBloodGroupWithPatient(this as any, e.params);

      case "getBloodTransfusion":
        return BLBI.getBloodTransfusion(this as any, e.params);

      case "getEncounterStatus":
        return CoreI.getEncounterStatus(this as any, e.params);

      // Multiple possible modules Core, PRX. Pick the first.
      case "getEncounter":
        return CoreI.getEncounter(this as any, e.params);

      case "putEncounter":
        return CoreI.putEncounter(this as any, e.params);

      case "getNationalities":
        return CoreI.getNationalities(this as any, e.params);

      case "getDistrict":
        return CoreI.getDistrict(this as any, e.params);

      case "getCity":
        return CoreI.getCity(this as any, e.params);

      case "getListPreName":
        return CoreI.getListPreName(this as any, e.params);

      case "getProvince":
        return CoreI.getProvince(this as any, e.params);

      case "getCountry":
        return CoreI.getCountry(this as any, e.params);

      case "getReligion":
        return CoreI.getReligion(this as any, e.params);

      case "getConstance":
        return CoreI.getConstance(this as any, e.params);

      case "getChoices":
        return CoreI.getChoices(this as any, e.params);

      case "getChoicesEpisodeType":
        return CoreI.getChoicesEpisodeType(this as any, e.params);

      case "createEpisode":
        return CoreI.createEpisode(this as any, e.params);

      case "getEpisode":
        return CoreI.getEpisode(this as any, e.params);

      case "getEpisodeFromEN":
        return CoreI.getEpisodeFromEN(this as any, e.params);

      case "getEpisodeList":
        return CoreI.getEpisodeList(this as any, e.params);

      case "changeENToEpisode":
        return CoreI.changeENToEpisode(this as any, e.params);

      case "cancelENFromEpisode":
        return CoreI.cancelENFromEpisode(this as any, e.params);

      case "getENListFromEpisode":
        return CoreI.getENListFromEpisode(this as any, e.params);

      case "getDoctorList":
        return CoreI.getDoctorList(this as any, e.params);

      case "getDoctorNameCodeList":
        return CoreI.getDoctorNameCodeList(this as any, e.params);

      case "getSpeciality":
        return CoreI.getSpeciality(this as any, e.params);

      case "getProgressionCycleByEmr":
        return CoreI.getProgressionCycleByEmr(this as any, e.params);

      case "getProgressionCycle":
        return CoreI.getProgressionCycle(this as any, e.params);

      case "getClinicalTermSet":
        return CoreI.getClinicalTermSet(this as any, e.params);

      case "getClinicalTerm":
        return CoreI.getClinicalTerm(this as any, e.params);

      case "getBarcodePrefix":
        return CoreI.getBarcodePrefix(this as any, e.params);

      case "getDefaultBarcode":
        return CoreI.getDefaultBarcode(this as any, e.params);

      case "getRejectedOrder":
        return CoreI.getRejectedOrder(this as any, e.params);

      case "getCleaningChoices":
        return CoreI.getCleaningChoices(this as any, e.params);

      case "getCareer":
        return CoreI.getCareer(this as any, e.params);

      case "getICD10ListWithCode":
        return CoreI.getICD10ListWithCode(this as any, e.params);

      case "getICD9CMListWithCode":
        return CoreI.getICD9CMListWithCode(this as any, e.params);

      case "getICD10ListWithTerm":
        return CoreI.getICD10ListWithTerm(this as any, e.params);

      case "getICD9CMListWithTerm":
        return CoreI.getICD9CMListWithTerm(this as any, e.params);

      case "getICD10ListWithMedTerm":
        return CoreI.getICD10ListWithMedTerm(this as any, e.params);

      case "getICD9CMListWithMedTerm":
        return CoreI.getICD9CMListWithMedTerm(this as any, e.params);

      case "getMiscellaneous":
        return CoreI.getMiscellaneous(this as any, e.params);

      case "getICD10SublevelListWithCode":
        return CoreI.getICD10SublevelListWithCode(this as any, e.params);

      case "getICD9CMSublevelListWithCode":
        return CoreI.getICD9CMSublevelListWithCode(this as any, e.params);

      case "postMiscellaneousOrderPreview":
        return CoreI.postMiscellaneousOrderPreview(this as any, e.params);

      case "getMiscellaneousOrder":
        return CoreI.getMiscellaneousOrder(this as any, e.params);

      case "deleteMiscellaneousOrder":
        return CoreI.deleteMiscellaneousOrder(this as any, e.params);

      case "patchMiscellaneousOrder":
        return CoreI.patchMiscellaneousOrder(this as any, e.params);

      case "postMiscellaneousOrderCreate":
        return CoreI.postMiscellaneousOrderCreate(this as any, e.params);

      case "getDivision":
        return CoreI.getDivision(this as any, e.params);

      case "getDivisionDetail":
        return CoreI.getDivisionDetail(this as any, e.params);

      case "getDivisionForOPD":
        return CoreI.getDivisionForOPD(this as any, e.params);

      case "getDivisionChoice":
        return CoreI.getDivisionChoice(this as any, e.params);

      case "getDivisionForOPDChoice":
        return CoreI.getDivisionForOPDChoice(this as any, e.params);

      case "getDoctorChoice":
        return CoreI.getDoctorChoice(this as any, e.params);

      case "getCurrentDoctor":
        return CoreI.getCurrentDoctor(this as any, e.params);

      case "deleteProgressionCycle":
        return CoreI.deleteProgressionCycle(this as any, e.params);

      case "postProgressionCycle":
        return CoreI.postProgressionCycle(this as any, e.params);

      case "putProgressionCycle":
        return CoreI.putProgressionCycle(this as any, e.params);

      case "getEncounterSearch":
        return CoreI.getEncounterSearch(this as any, e.params);

      case "getDocumentType":
        return CoreI.getDocumentType(this as any, e.params);

      case "getDocumentCategory":
        return CoreI.getDocumentCategory(this as any, e.params);

      case "getDoctor":
        return CoreI.getDoctor(this as any, e.params);

      case "getScannedDocument":
        return CoreI.getScannedDocument(this as any, e.params);

      case "getScannedDocumentByGroup":
        return CoreI.getScannedDocumentByGroup(this as any, e.params);

      case "putScannedDocumentUpdateSecret":
        return CoreI.putScannedDocumentUpdateSecret(this as any, e.params);

      case "patchScannedDocument":
        return CoreI.patchScannedDocument(this as any, e.params);

      case "postScannedDocument":
        return CoreI.postScannedDocument(this as any, e.params);

      case "getChoicesCheckoutCause":
        return CoreI.getChoicesCheckoutCause(this as any, e.params);

      case "getZoneOfDivision":
        return CoreI.getZoneOfDivision(this as any, e.params);

      case "changeZone":
        return CoreI.changeZone(this as any, e.params);

      case "getEncounterSearchDetail":
        return CoreI.getEncounterSearchDetail(this as any, e.params);

      case "getTaskTrackingResult":
        return CoreI.getTaskTrackingResult(this as any, e.params);

      case "getChoicesBillTransactionTypeIPD":
        return CoreI.getChoicesBillTransactionTypeIPD(this as any, e.params);

      case "getChoicesAdmitOrderType":
        return CoreI.getChoicesAdmitOrderType(this as any, e.params);

      case "getEncounterPatient":
        return CoreI.getEncounterPatient(this as any, e.params);

      case "getProduct":
        return CoreI.getProduct(this as any, e.params);

      case "postMiscellaneousOrderListCreate":
        return CoreI.postMiscellaneousOrderListCreate(this as any, e.params);

      case "postPatientAddress":
        return CoreI.postPatientAddress(this as any, e.params);

      case "getPatientAddressList":
        return CoreI.getPatientAddressList(this as any, e.params);

      case "getPatientAddressDetail":
        return CoreI.getPatientAddressDetail(this as any, e.params);

      case "putPatientAddressDetail":
        return CoreI.putPatientAddressDetail(this as any, e.params);

      case "deletePatientAddressDetail":
        return CoreI.deletePatientAddressDetail(this as any, e.params);

      case "getChoicesANSOrderStatus":
        return CoreI.getChoicesANSOrderStatus(this as any, e.params);

      case "getDoctorOrderDetail":
        return CoreI.getDoctorOrderDetail(this as any, e.params);

      case "getEncounterPatientOptimized":
        return CoreI.getEncounterPatientOptimized(this as any, e.params);

      case "getPatientDiagnosisList":
        return CoreI.getPatientDiagnosisList(this as any, e.params);

      case "getChoicesSupplyOrderMode":
        return CoreI.getChoicesSupplyOrderMode(this as any, e.params);

      case "getChoicesSupplyOrderEligibility":
        return CoreI.getChoicesSupplyOrderEligibility(this as any, e.params);

      case "getOperatingOrderDetailByEmr":
        return CoreI.getOperatingOrderDetailByEmr(this as any, e.params);

      case "getDoctorDetail":
        return CoreI.getDoctorDetail(this as any, e.params);

      case "getPatientDetailView":
        return CoreI.getPatientDetailView(this as any, e.params);

      case "getDiagnosisMedicalRecordDetail":
        return CoreI.getDiagnosisMedicalRecordDetail(this as any, e.params);

      case "getTreatmentDetail":
        return CoreI.getTreatmentDetail(this as any, e.params);

      case "getHospitalNameForPrintList":
        return CoreI.getHospitalNameForPrintList(this as any, e.params);

      case "getPatientAllergyForPrintList":
        return CoreI.getPatientAllergyForPrintList(this as any, e.params);

      case "getPreNameForPrintList":
        return CoreI.getPreNameForPrintList(this as any, e.params);

      case "checkDoctorFeeOrderWithEMR":
        return DFCI.checkDoctorFeeOrderWithEMR(this as any, e.params);

      case "getAdmissionForm":
        return DPII.getAdmissionForm(this as any, e.params);

      case "getAdmitOrderForPrintList":
        return CoreI.getAdmitOrderForPrintList(this as any, e.params);

      case "getCudentMedCertForPrintList":
        return CoreI.getCudentMedCertForPrintList(this as any, e.params);

      case "getBilEncounterSummaryForPrintList":
        return CoreI.getBilEncounterSummaryForPrintList(this as any, e.params);

      case "getIpdMedicalBilForPrintList":
        return CoreI.getIpdMedicalBilForPrintList(this as any, e.params);

      case "getInvoiceItemList":
        return CoreI.getInvoiceItemList(this as any, e.params);

      case "putAdmissionForm":
        return DPII.putAdmissionForm(this as any, e.params);

      case "createProgressionNote":
        return DPII.createProgressionNote(this as any, e.params);

      case "putProgressNote":
        return DPII.putProgressNote(this as any, e.params);

      case "putProgressNoteById":
        return DPII.putProgressNoteById(this as any, e.params);

      case "dpoService":
        return DPOI.dpoService(this as any, e.params);

      case "getMedicalRecord":
        return DPOI.getMedicalRecord(this as any, e.params);

      case "discharged":
        return DPOI.discharged(this as any, e.params);

      case "cancelCheckIn":
        return DPOI.cancelCheckIn(this as any, e.params);

      case "getDiagnosis":
        return DPOI.getDiagnosis(this as any, e.params);

      case "updateDiagnosis":
        return DPOI.updateDiagnosis(this as any, e.params);

      case "getPatientDiagnosis":
        return DPOI.getPatientDiagnosis(this as any, e.params);

      case "getClinialType":
        return DPOI.getClinialType(this as any, e.params);

      case "getDiagnosisTemplate":
        return DPOI.getDiagnosisTemplate(this as any, e.params);

      case "getDoctorCertificateType":
        return DPOI.getDoctorCertificateType(this as any, e.params);

      case "postDoctorCertificate":
        return DPOI.postDoctorCertificate(this as any, e.params);

      case "getDiagnosisSummary":
        return DPOI.getDiagnosisSummary(this as any, e.params);

      case "getDoctorCertificatesPrintlog":
        return DPOI.getDoctorCertificatesPrintlog(this as any, e.params);

      case "getDoctorOrder":
        return DPOI.getDoctorOrder(this as any, e.params);

      case "putDoctorOrder":
        return DPOI.putDoctorOrder(this as any, e.params);

      case "postDoctorConsultOrder":
        return DPOI.postDoctorConsultOrder(this as any, e.params);

      case "getDoctorConsultOrderWithId":
        return DPOI.getDoctorConsultOrderWithId(this as any, e.params);

      case "updateDoctorConsultOrderWithId":
        return DPOI.updateDoctorConsultOrderWithId(this as any, e.params);

      case "getMedicalRecordGallery":
        return DPOI.getMedicalRecordGallery(this as any, e.params);

      case "postMedicalRecordGallery":
        return DPOI.postMedicalRecordGallery(this as any, e.params);

      case "putMedicalRecordPicture":
        return DPOI.putMedicalRecordPicture(this as any, e.params);

      case "getTemplateGalleryImage":
        return DPOI.getTemplateGalleryImage(this as any, e.params);

      case "_convertToConsultOrderModel":
        return DPOI._convertToConsultOrderModel(this as any, e.params);

      case "estimateDoctorOrder":
        return DPOI.estimateDoctorOrder(this as any, e.params);

      // case "getMedicalRecordEmrDetail":
      //   return DPOI.getMedicalRecordEmrDetail(this as any, e.params);

      case "getPatientHistoryEMR":
        return DPOI.getPatientHistoryEMR(this as any, e.params);

      case "getSensitiveNoteEMR":
        return DPOI.getSensitiveNoteEMR(this as any, e.params);

      case "postSensitiveNoteEMR":
        return DPOI.postSensitiveNoteEMR(this as any, e.params);

      case "putSensitiveNoteEMR":
        return DPOI.putSensitiveNoteEMR(this as any, e.params);

      case "putPatientHistoryEMR":
        return DPOI.putPatientHistoryEMR(this as any, e.params);

      // case "getPhysicalExamOrgan":
      //   return DPOI.getPhysicalExamOrgan(this as any, e.params);

      // case "postPatientScreenNew":
      //   return DPOI.postPatientScreenNew(this as any, e.params);

      // case "putPatientScreenUpdate":
      //   return DPOI.putPatientScreenUpdate(this as any, e.params);

      case "patchPatientDiagnosis":
        return DPOI.patchPatientDiagnosis(this as any, e.params);

      case "getProviderInfo":
        return HRMI.getProviderInfo(this as any, e.params);

      case "getRoomList":
        return ICUI.getRoomList(this as any, e.params);

      case "getEventTypeChoices":
        return ICUI.getEventTypeChoices(this as any, e.params);

      case "getEncounterDoctorOrder":
        return ICUI.getEncounterDoctorOrder(this as any, e.params);

      case "putMonitorEvent":
        return ICUI.putMonitorEvent(this as any, e.params);

      case "getMonitorEvent":
        return ICUI.getMonitorEvent(this as any, e.params);

      case "deleteMonitorEvent":
        return ICUI.deleteMonitorEvent(this as any, e.params);

      case "getMedicationsRecordChoices":
        return ICUI.getMedicationsRecordChoices(this as any, e.params);

      case "createMedicationsRecordChoices":
        return ICUI.createMedicationsRecordChoices(this as any, e.params);

      case "getFlowSheetVitalSigns":
        return ICUI.getFlowSheetVitalSigns(this as any, e.params);

      case "getFlowSheetMedication":
        return ICUI.getFlowSheetMedication(this as any, e.params);

      case "getFlowSheetVentilater":
        return ICUI.getFlowSheetVentilater(this as any, e.params);

      case "getFlowSheetArterial":
        return ICUI.getFlowSheetArterial(this as any, e.params);

      case "getFlowSheetOverALLBalance":
        return ICUI.getFlowSheetOverALLBalance(this as any, e.params);

      case "getGraphicSheetOverAllBalance":
        return ICUI.getGraphicSheetOverAllBalance(this as any, e.params);

      case "getIcuIntakeOutputDetail":
        return ICUI.getIcuIntakeOutputDetail(this as any, e.params);

      case "getIntakeOutputChoise":
        return ICUI.getIntakeOutputChoise(this as any, e.params);

      // Multiple possible modules ICU, PTM. Pick the first.
      case "getIntakeOutput":
        return ICUI.getIntakeOutput(this as any, e.params);

      case "getFlowsheetDiet":
        return ICUI.getFlowsheetDiet(this as any, e.params);

      case "putMedicationRecordItem":
        return ICUI.putMedicationRecordItem(this as any, e.params);

      case "postMedicationRecordItem":
        return ICUI.postMedicationRecordItem(this as any, e.params);

      case "postGraphicSheetPrint":
        return ICUI.postGraphicSheetPrint(this as any, e.params);

      case "postFlowSheetPrint":
        return ICUI.postFlowSheetPrint(this as any, e.params);

      case "postIntakeOutputRecordItemCreateUpdate":
        return ICUI.postIntakeOutputRecordItemCreateUpdate(this as any, e.params);

      case "getPeriodWorkerTimeSlot":
        return ICUI.getPeriodWorkerTimeSlot(this as any, e.params);

      case "icuService":
        return ICUI.icuService(this as any, e.params);

      case "getImagingExamResult":
        return IMEI.getImagingExamResult(this as any, e.params);

      case "getSentClaimChoices":
        return INFI.getSentClaimChoices(this as any, e.params);

      case "getChoicesAdmitSource":
        return INFI.getChoicesAdmitSource(this as any, e.params);

      case "getChoicesPreDischargeType":
        return INFI.getChoicesPreDischargeType(this as any, e.params);

      case "getChoicesDischargeType":
        return INFI.getChoicesDischargeType(this as any, e.params);

      case "getChoicesDivision":
        return INFI.getChoicesDivision(this as any, e.params);

      case "getChoicesSentClaimStatus":
        return INFI.getChoicesSentClaimStatus(this as any, e.params);

      case "createARTransaction":
        return INFI.createARTransaction(this as any, e.params);

      case "getARTransaction":
        return INFI.getARTransaction(this as any, e.params);

      case "getCoveragePayerSentClaimGroup":
        return INFI.getCoveragePayerSentClaimGroup(this as any, e.params);

      case "getBillTransactionIPD":
        return INFI.getBillTransactionIPD(this as any, e.params);

      case "getBillTransactionIPDWithId":
        return INFI.getBillTransactionIPDWithId(this as any, e.params);

      case "updateBillTransactionIPDWithId":
        return INFI.updateBillTransactionIPDWithId(this as any, e.params);

      case "updateIPDDiagnosisSentClaimWithId":
        return INFI.updateIPDDiagnosisSentClaimWithId(this as any, e.params);

      case "updateIPDProcedureSentClaimWithId":
        return INFI.updateIPDProcedureSentClaimWithId(this as any, e.params);

      case "putBillTransactionUpdateStatus":
        return INFI.putBillTransactionUpdateStatus(this as any, e.params);

      case "putBillTransaction":
        return INFI.putBillTransaction(this as any, e.params);

      case "getBillTransactionIPDSummary":
        return INFI.getBillTransactionIPDSummary(this as any, e.params);

      case "getIPDDiagnosisSentClaim":
        return INFI.getIPDDiagnosisSentClaim(this as any, e.params);

      case "getIPDProcedureSentClaim":
        return INFI.getIPDProcedureSentClaim(this as any, e.params);

      case "getBillTransactionIPDItem":
        return INFI.getBillTransactionIPDItem(this as any, e.params);

      case "doGenerateSentClaimDataIPD":
        return INFI.doGenerateSentClaimDataIPD(this as any, e.params);

      case "arTaskTrackingIPDGenerateSentClaim":
        return INFI.arTaskTrackingIPDGenerateSentClaim(this as any, e.params);

      case "arTaskTrackingIPDUpdateSentClaim":
        return INFI.arTaskTrackingIPDUpdateSentClaim(this as any, e.params);

      case "updateSentClaimDataIPDFromARId":
        return INFI.updateSentClaimDataIPDFromARId(this as any, e.params);

      case "generateSentClaimIPDFileFromARId":
        return INFI.generateSentClaimIPDFileFromARId(this as any, e.params);

      case "importResponseFileIPD":
        return INFI.importResponseFileIPD(this as any, e.params);

      case "getSentClaimTransactionIPD":
        return INFI.getSentClaimTransactionIPD(this as any, e.params);

      case "getEncounterFromARId":
        return INFI.getEncounterFromARId(this as any, e.params);

      case "getCenterLabDivision":
        return LABI.getCenterLabDivision(this as any, e.params);

      case "getCentalLabTestResultFitlerList":
        return LABI.getCentalLabTestResultFitlerList(this as any, e.params);

      case "getCentalLabTestResultComparable":
        return LABI.getCentalLabTestResultComparable(this as any, e.params);

      case "getInterfaceSummaryReportDetail":
        return LABI.getInterfaceSummaryReportDetail(this as any, e.params);

      case "getCentralLabResultList":
        return LABI.getCentralLabResultList(this as any, e.params);

      case "getSearchQueue":
        return LRMI.getSearchQueue(this as any, e.params);

      case "getANCRecordList":
        return LRMI.getANCRecordList(this as any, e.params);

      case "getPreviousPregnancy":
        return LRMI.getPreviousPregnancy(this as any, e.params);

      case "getANCSummary":
        return LRMI.getANCSummary(this as any, e.params);

      case "getANCItem":
        return LRMI.getANCItem(this as any, e.params);

      case "getANCLab":
        return LRMI.getANCLab(this as any, e.params);

      case "getFetalLie":
        return LRMI.getFetalLie(this as any, e.params);

      case "postLabInvestigation":
        return LRMI.postLabInvestigation(this as any, e.params);

      case "getLRLab":
        return LRMI.getLRLab(this as any, e.params);

      case "postSaveANCRecord":
        return LRMI.postSaveANCRecord(this as any, e.params);

      case "putLabInvestigation":
        return LRMI.putLabInvestigation(this as any, e.params);

      case "getBirthCertificateApplication":
        return LRMI.getBirthCertificateApplication(this as any, e.params);

      case "postBirthCertificateApplication":
        return LRMI.postBirthCertificateApplication(this as any, e.params);

      case "putBirthCertificateApplication":
        return LRMI.putBirthCertificateApplication(this as any, e.params);

      case "putPrintBirthCertificateApplication":
        return LRMI.putPrintBirthCertificateApplication(this as any, e.params);

      case "getObstetricBasicInfo":
        return LRMI.getObstetricBasicInfo(this as any, e.params);

      case "postObstetricBasicInfo":
        return LRMI.postObstetricBasicInfo(this as any, e.params);

      case "putObstetricBasicInfo":
        return LRMI.putObstetricBasicInfo(this as any, e.params);

      case "putPrintObstetric":
        return LRMI.putPrintObstetric(this as any, e.params);

      case "getObstetricLabour":
        return LRMI.getObstetricLabour(this as any, e.params);

      case "postObstetricLabour":
        return LRMI.postObstetricLabour(this as any, e.params);

      case "putObstetricLabour":
        return LRMI.putObstetricLabour(this as any, e.params);

      case "getObstetricInfant":
        return LRMI.getObstetricInfant(this as any, e.params);

      case "postObstetricInfant":
        return LRMI.postObstetricInfant(this as any, e.params);

      case "putObstetricInfant":
        return LRMI.putObstetricInfant(this as any, e.params);

      case "getObstetricPostLabor":
        return LRMI.getObstetricPostLabor(this as any, e.params);

      case "postObstetricPostLabour":
        return LRMI.postObstetricPostLabour(this as any, e.params);

      case "putObstetricPostLabour":
        return LRMI.putObstetricPostLabour(this as any, e.params);

      case "getEDC":
        return LRMI.getEDC(this as any, e.params);

      case "postNewborn":
        return LRMI.postNewborn(this as any, e.params);

      case "getCheckOutChoice":
        return LRMI.getCheckOutChoice(this as any, e.params);

      case "putLRCheckOut":
        return LRMI.putLRCheckOut(this as any, e.params);

      case "printANCRecordByEncounter":
        return LRMI.printANCRecordByEncounter(this as any, e.params);

      case "getPrintAPI":
        return MixInI.getPrintAPI(this as any, e.params);

      case "getRegisterByTokenFacebook":
        return MixInI.getRegisterByTokenFacebook(this as any, e.params);

      case "postRegisterByTokenFacebook":
        return MixInI.postRegisterByTokenFacebook(this as any, e.params);

      case "postRegisterByTokenFacebookConnect":
        return MixInI.postRegisterByTokenFacebookConnect(this as any, e.params);

      case "postRegisterByTokenGoogle":
        return MixInI.postRegisterByTokenGoogle(this as any, e.params);

      case "postRegisterByTokenGoogleConnect":
        return MixInI.postRegisterByTokenGoogleConnect(this as any, e.params);

      case "checkManufacturer":
        return MSDInterface.checkManufacturer(this as any, e.params);

      case "checkUserTokenize":
        return MSDInterface.checkUserTokenize(this as any, e.params);

      case "getSupplyDeliveryAction":
        return MSDInterface.getSupplyDeliveryAction(this as any, e.params);

      // Multiple possible modules MSG, PRX. Pick the first.
      case "getLatestChatChannel":
        return MSGI.getLatestChatChannel(this as any, e.params);

      // Multiple possible modules MSG, PRX. Pick the first.
      case "getChatChannelMessageList":
        return MSGI.getChatChannelMessageList(this as any, e.params);

      case "getChatChannelMessageListMSG":
        return MSGI.getChatChannelMessageListMSG(this as any, e.params);

      // Multiple possible modules MSG, PRX. Pick the first.
      case "getMessageFromURL":
        return MSGI.getMessageFromURL(this as any, e.params);

      // Multiple possible modules MSG, PRX. Pick the first.
      case "postChatChannelMessage":
        return MSGI.postChatChannelMessage(this as any, e.params);

      case "postChatChannelMessageMSG":
        return MSGI.postChatChannelMessageMSG(this as any, e.params);

      case "postReadMessage":
        return MSGI.postReadMessage(this as any, e.params);

      case "postUpdateSubscription":
        return MSGI.postUpdateSubscription(this as any, e.params);

      // ORMInterface
      case "GetCheckoutMaster":
        return ORMInterface.GetCheckoutMaster(this as any);
      case "GetDischargeMaster":
        return ORMInterface.GetDischargeMaster(this as any);
      case "ORCheckout":
        return ORMInterface.ORCheckout(this as any, e.params);
      case "ORDischarge":
        return ORMInterface.ORDischarge(this as any, e.params);
      case "ORConfirmCompensation":
        return ORMInterface.ORConfirmCompensation(this as any, e.params);
      case "ORConfirmAdmit":
        return ORMInterface.ORConfirmAdmit(this as any, e.params);
      case "ORCancelDischarge":
        return ORMInterface.ORCancelDischarge(this as any, e.params);
      case "GetOROrderByID":
        return ORMInterface.GetOROrderByID(this as any, e.params);
      case "SearchORItemList":
        return ORMInterface.SearchORItemList(this as any, e.params);
      case "PrintOperativeNote":
        return ORMInterface.PrintOperativeNote(this as any, e.params);

      // ORMI
      case "getOperatingOrder":
        return ORMI.getOperatingOrder(this as any, e.params);

      case "postDeliverOperatingAppointment":
        return ORMI.postDeliverOperatingAppointment(this as any, e.params);

      case "getOrLocation":
        return ORMI.getOrLocation(this as any, e.params);

      case "getOperativeImage":
        return ORMI.getOperativeImage(this as any, e.params);

      case "getOperatingProcedureSummary":
        return ORMI.getOperatingProcedureSummary(this as any, e.params);

      case "printOperativeNote":
        return ORMI.printOperativeNote(this as any, e.params);

      case "newPRXService":
        return PRXI.newPRXService(this as any, e.params);

      case "getDiagRule":
        return PRXI.getDiagRule(this as any, e.params);

      case "getDiagFormClassify":
        return PRXI.getDiagFormClassify(this as any, e.params);

      case "getDiagForm":
        return PRXI.getDiagForm(this as any, e.params);

      case "getDiagFormDetail":
        return PRXI.getDiagFormDetail(this as any, e.params);

      case "getDivisionHasUser":
        return PRXI.getDivisionHasUser(this as any, e.params);

      case "getDivisionProfile":
        return PRXI.getDivisionProfile(this as any, e.params);

      case "createDivisionHasUser":
        return PRXI.createDivisionHasUser(this as any, e.params);

      case "getDiagRuleDetail":
        return PRXI.getDiagRuleDetail(this as any, e.params);

      case "postDiagRule":
        return PRXI.postDiagRule(this as any, e.params);

      case "postTuhSetPatientHn":
        return PRXI.postTuhSetPatientHn(this as any, e.params);

      case "postListPatientFromDiagForm":
        return PRXI.postListPatientFromDiagForm(this as any, e.params);

      case "postListPatientFromPatient":
        return PRXI.postListPatientFromPatient(this as any, e.params);

      case "getProxyPatientHasDivisionNotFollow":
        return PRXI.getProxyPatientHasDivisionNotFollow(this as any, e.params);

      case "getProxyPatientHasDivisionPatientChat":
        return PRXI.getProxyPatientHasDivisionPatientChat(this as any, e.params);

      case "patchDiagRuleDetail":
        return PRXI.patchDiagRuleDetail(this as any, e.params);

      case "patchDiagRuleName":
        return PRXI.patchDiagRuleName(this as any, e.params);

      case "patchDiagRulePublish":
        return PRXI.patchDiagRulePublish(this as any, e.params);

      case "patchDiagForm":
        return PRXI.patchDiagForm(this as any, e.params);

      case "getV2EncounterTriage":
        return PRXI.getV2EncounterTriage(this as any, e.params);

      case "postDiagFormMonitor":
        return PRXI.postDiagFormMonitor(this as any, e.params);

      case "patchDiagRuleActive":
        return PRXI.patchDiagRuleActive(this as any, e.params);

      case "getPublishedDiagRule":
        return PRXI.getPublishedDiagRule(this as any, e.params);

      case "postPublishedDiagRule":
        return PRXI.postPublishedDiagRule(this as any, e.params);

      case "getTagEconsentOptions":
        return PRXI.getTagEconsentOptions(this as any, e.params);

      case "patchPublishedDiagRule":
        return PRXI.patchPublishedDiagRule(this as any, e.params);

      case "getTriageLevelClassify":
        return PRXI.getTriageLevelClassify(this as any, e.params);

      case "getClassifyUser":
        return PRXI.getClassifyUser(this as any, e.params);

      case "getMasterTriageLevelClassify":
        return PRXI.getMasterTriageLevelClassify(this as any, e.params);

      case "getEncounterTriage":
        return PRXI.getEncounterTriage(this as any, e.params);

      case "geNurseNoteList":
        return PRXI.geNurseNoteList(this as any, e.params);

      case "geProgressNoteList":
        return PRXI.geProgressNoteList(this as any, e.params);

      case "getChannelDetail":
        return PRXI.getChannelDetail(this as any, e.params);

      case "geNurseNoteEncounter":
        return PRXI.geNurseNoteEncounter(this as any, e.params);

      case "getProxyPatient":
        return PRXI.getProxyPatient(this as any, e.params);

      case "getProxyPatientAllergy":
        return PRXI.getProxyPatientAllergy(this as any, e.params);

      case "getProxyPatientList":
        return PRXI.getProxyPatientList(this as any, e.params);

      case "patchProxyPatientHasDivision":
        return PRXI.patchProxyPatientHasDivision(this as any, e.params);

      case "getProxyPatientHasDivisionAdmin":
        return PRXI.getProxyPatientHasDivisionAdmin(this as any, e.params);

      case "patchProxyPatientHasDivisionAdmin":
        return PRXI.patchProxyPatientHasDivisionAdmin(this as any, e.params);

      case "patchEncounterReclassify":
        return PRXI.patchEncounterReclassify(this as any, e.params);

      case "getChatChannel":
        return PRXI.getChatChannel(this as any, e.params);

      case "getProxyPatientHasDivisionIdAdmin":
        return PRXI.getProxyPatientHasDivisionIdAdmin(this as any, e.params);

      case "getTuhUsersList":
        return PRXI.getTuhUsersList(this as any, e.params);

      case "getProxyPatientHasDivision":
        return PRXI.getProxyPatientHasDivision(this as any, e.params);

      case "getPatient":
        return PRXI.getPatient(this as any, e.params);

      case "patchPatient":
        return PRXI.patchPatient(this as any, e.params);

      case "postEncounterPatientAppointment":
        return PRXI.postEncounterPatientAppointment(this as any, e.params);

      case "getDoctorWorkSchedule":
        return PRXI.getDoctorWorkSchedule(this as any, e.params);

      case "getAvailableDivisionServiceBlock":
        return PRXI.getAvailableDivisionServiceBlock(this as any, e.params);

      case "postSelectDivisionServiceBlock":
        return PRXI.postSelectDivisionServiceBlock(this as any, e.params);

      case "postRequestChangeDivisionServiceBlock":
        return PRXI.postRequestChangeDivisionServiceBlock(this as any, e.params);

      case "getEncounterTriageDetail":
        return PRXI.getEncounterTriageDetail(this as any, e.params);

      case "getPatientQueue":
        return PRXI.getPatientQueue(this as any, e.params);

      case "getAppointedPatientQueue":
        return PRXI.getAppointedPatientQueue(this as any, e.params);

      case "getShippingAddress":
        return PRXI.getShippingAddress(this as any, e.params);

      case "postShippingAddress":
        return PRXI.postShippingAddress(this as any, e.params);

      case "getInitPatientAddress":
        return PRXI.getInitPatientAddress(this as any, e.params);

      case "getDashboard":
        return PRXI.getDashboard(this as any, e.params);

      case "getOfficialAccountDashboard":
        return PRXI.getOfficialAccountDashboard(this as any, e.params);

      // Remove Duplicate
      // case "getDashboardAppointment":
      //   return PRXI.getDashboardAppointment(this as any, e.params);

      case "getResolveChatChannel":
        return PRXI.getResolveChatChannel(this as any, e.params);

      case "postRequestOA":
        return PRXI.postRequestOA(this as any, e.params);

      case "getListOA":
        return PRXI.getListOA(this as any, e.params);

      case "postFollowOA":
        return PRXI.postFollowOA(this as any, e.params);

      case "getOAInviteLink":
        return PRXI.getOAInviteLink(this as any, e.params);

      case "postCreatejoinOARequest":
        return PRXI.postCreatejoinOARequest(this as any, e.params);

      case "getListJoinOARequest":
        return PRXI.getListJoinOARequest(this as any, e.params);

      case "postApproveJoinOARequest":
        return PRXI.postApproveJoinOARequest(this as any, e.params);

      case "postCreateUpdateSchedule":
        return PRXI.postCreateUpdateSchedule(this as any, e.params);

      case "postPatientFromDiagRule":
        return PRXI.postPatientFromDiagRule(this as any, e.params);

      case "deleteJoinOARequest":
        return PRXI.deleteJoinOARequest(this as any, e.params);

      case "deleteDivisionHasUserOA":
        return PRXI.deleteDivisionHasUserOA(this as any, e.params);

      case "getListDivisionHasUserOA":
        return PRXI.getListDivisionHasUserOA(this as any, e.params);

      case "getListAvailabelTraigeLevel":
        return PRXI.getListAvailabelTraigeLevel(this as any, e.params);

      case "getListUserRoleOA":
        return PRXI.getListUserRoleOA(this as any, e.params);

      case "getOADivisionProfile":
        return PRXI.getOADivisionProfile(this as any, e.params);

      case "getListOARequestCheck":
        return PRXI.getListOARequestCheck(this as any, e.params);

      case "patchDivisionHasUserOA":
        return PRXI.patchDivisionHasUserOA(this as any, e.params);

      case "patchOADivisionProfile":
        return PRXI.patchOADivisionProfile(this as any, e.params);

      case "getOAUserProfile":
        return PRXI.getOAUserProfile(this as any, e.params);

      case "getListSchedule":
        return PRXI.getListSchedule(this as any, e.params);

      case "getDivisionClassify":
        return PRXI.getDivisionClassify(this as any, e.params);

      case "getChatChannelTriageLevel":
        return PRXI.getChatChannelTriageLevel(this as any, e.params);

      case "getListChatChannelTriageLevelDiagRule":
        return PRXI.getListChatChannelTriageLevelDiagRule(this as any, e.params);

      case "getListAvailabelTriageLevelDiagRule":
        return PRXI.getListAvailabelTriageLevelDiagRule(this as any, e.params);

      case "getPatientFromDiagRule":
        return PRXI.getPatientFromDiagRule(this as any, e.params);

      case "putPatientFromDiagRule":
        return PRXI.putPatientFromDiagRule(this as any, e.params);

      case "patchOAUserProfile":
        return PRXI.patchOAUserProfile(this as any, e.params);

      case "getVaccineHospital":
        return PRXI.getVaccineHospital(this as any, e.params);

      case "getAvailableVaccineDivision":
        return PRXI.getAvailableVaccineDivision(this as any, e.params);

      case "postVaccineServiceBlock":
        return PRXI.postVaccineServiceBlock(this as any, e.params);

      case "postVaccineNote":
        return PRXI.postVaccineNote(this as any, e.params);

      case "putVaccineServiceBlock":
        return PRXI.putVaccineServiceBlock(this as any, e.params);

      case "deleteVaccineServiceBlock":
        return PRXI.deleteVaccineServiceBlock(this as any, e.params);

      case "getListVaccine":
        return PRXI.getListVaccine(this as any, e.params);

      case "getListVaccineLot":
        return PRXI.getListVaccineLot(this as any, e.params);

      case "getListVaccineNote":
        return PRXI.getListVaccineNote(this as any, e.params);

      case "getVaccineNoteDetail":
        return PRXI.getVaccineNoteDetail(this as any, e.params);

      case "patchVaccineNote":
        return PRXI.patchVaccineNote(this as any, e.params);

      case "postRequestBotMessage":
        return PRXI.postRequestBotMessage(this as any, e.params);

      case "getPatientData":
        return PTMI.getPatientData(this as any, e.params);

      case "getPatientWardData":
        return PTMI.getPatientWardData(this as any, e.params);

      case "periodWorkerOptions":
        return PTMI.periodWorkerOptions(this as any, e.params);

      case "getFlowSheet":
        return PTMI.getFlowSheet(this as any, e.params);

      case "getPatientAssessment":
        return PTMI.getPatientAssessment(this as any, e.params);

      case "getFormDataLatest":
        return PTMI.getFormDataLatest(this as any, e.params);

      case "getFormDataActionLog":
        return PTMI.getFormDataActionLog(this as any, e.params);

      case "getPatientWeightAndHeight":
        return PTMI.getPatientWeightAndHeight(this as any, e.params);

      case "getVitalSignValue":
        return PTMI.getVitalSignValue(this as any, e.params);

      case "getVitalSignValueRaw":
        return PTMI.getVitalSignValueRaw(this as any, e.params);

      case "getMeasurement":
        return PTMI.getMeasurement(this as any, e.params);

      case "getVitalSignType":
        return PTMI.getVitalSignType(this as any, e.params);

      case "getVitalSign":
        return PTMI.getVitalSign(this as any, e.params);

      case "getLastHeight":
        return PTMI.getLastHeight(this as any, e.params);

      case "postMeasurement":
        return PTMI.postMeasurement(this as any, e.params);

      case "patchMeasurement":
        return PTMI.patchMeasurement(this as any, e.params);

      case "postVitalSignUpdate":
        return PTMI.postVitalSignUpdate(this as any, e.params);

      case "deleteVitalSign":
        return PTMI.deleteVitalSign(this as any, e.params);

      case "getMultidisciplinary":
        return PTMI.getMultidisciplinary(this as any, e.params);

      case "getMultidisciplinaryLogs":
        return PTMI.getMultidisciplinaryLogs(this as any, e.params);

      case "saveMultidisciplinary":
        return PTMI.saveMultidisciplinary(this as any, e.params);

      case "updateMultidisciplinary":
        return PTMI.updateMultidisciplinary(this as any, e.params);

      case "printMultidisciplinary":
        return PTMI.printMultidisciplinary(this as any, e.params);

      case "getFormType":
        return PTMI.getFormType(this as any, e.params);

      case "getFormDataNurseNote":
        return PTMI.getFormDataNurseNote(this as any, e.params);

      case "deleteMultidisciplinary":
        return PTMI.deleteMultidisciplinary(this as any, e.params);

      case "getNurseDiagnosisResultGroup":
        return PTMI.getNurseDiagnosisResultGroup(this as any, e.params);

      case "putNurseDiagPrintPhv":
        return PTMI.putNurseDiagPrintPhv(this as any, e.params);

      case "getNurseNoteLatest":
        return PTMI.getNurseNoteLatest(this as any, e.params);

      case "getNurseNoteItem":
        return PTMI.getNurseNoteItem(this as any, e.params);

      case "postNurseNoteItem":
        return PTMI.postNurseNoteItem(this as any, e.params);

      case "putNurseNoteItem":
        return PTMI.putNurseNoteItem(this as any, e.params);

      case "deleteNurseNoteItem":
        return PTMI.deleteNurseNoteItem(this as any, e.params);

      case "putNurseNote":
        return PTMI.putNurseNote(this as any, e.params);

      case "getDrOrder":
        return PTMI.getDrOrder(this as any, e.params);

      case "getVentilatorMode":
        return PTMI.getVentilatorMode(this as any, e.params);

      case "putEncounterVitalSignType":
        return PTMI.putEncounterVitalSignType(this as any, e.params);

      case "putRemoveEncounterVitalSignType":
        return PTMI.putRemoveEncounterVitalSignType(this as any, e.params);

      case "postFormData":
        return PTMI.postFormData(this as any, e.params);

      case "putFormData":
        return PTMI.putFormData(this as any, e.params);

      case "putMeasurement":
        return PTMI.putMeasurement(this as any, e.params);

      case "ptmService":
        return PTMI.ptmService(this as any, e.params);

      case "GetTriageLevel":
        return TriageI.GetTriageLevel(this as any, e.params);
      case "GetChoicesBarcode":
        return ReceiveOrderI.GetChoicesBarcode(this as any, e.params);

      case "createServiceSlot":
        return QUEI.createServiceSlot(this as any, e.params);

      case "updateServiceSlot":
        return QUEI.updateServiceSlot(this as any, e.params);

      case "loadServiceSlot":
        return QUEI.loadServiceSlot(this as any, e.params);

      case "loadDivisionServiceBlock":
        return QUEI.loadDivisionServiceBlock(this as any, e.params);

      case "getDivisionServiceBlockDetail":
        return QUEI.getDivisionServiceBlockDetail(this as any, e.params);

      case "listPatientAppointment":
        return QUEI.listPatientAppointment(this as any, e.params);

      case "getPatientAppointment":
        return QUEI.getPatientAppointment(this as any, e.params);

      case "updatePatientAppointment":
        return QUEI.updatePatientAppointment(this as any, e.params);

      case "getPatientAppointmentUpdate":
        return QUEI.getPatientAppointmentUpdate(this as any, e.params);

      case "getPatientInfo":
        return REGI.getPatientInfo(this as any, e.params);

      case "getSearchAllPatient":
        return REGI.getSearchAllPatient(this as any, e.params);

      case "QueueForPatient":
        return QueueForPatientInterface.QueueForPatient(this as any, e.params);

      // Ishealth-v3 port into CUDent (vise versa)
      // case "getPatientOldName":
      //   return REGI.getPatientOldName(this as any, e.params);

      case "getPatientNameWithID":
        return REGI.getPatientNameWithID(this as any, e.params);

      // Ishealth-v3 port into CUDent (vise versa)
      // case "getPatientByHN":
      //   return REGI.getPatientByHN(this as any, e.params);

      case "getBloodType":
        return REGI.getBloodType(this as any, e.params);

      case "regService":
        return REGI.regService(this as any, e.params);

      case "createUpdateRhbExamPlan":
        return RHBInterface.createUpdateRhbExamPlan(this as any, e.params);

      case "createUpdateRhbImage":
        return RHBInterface.createUpdateRhbImage(this as any, e.params);

      case "updateRhbExamPlanItemTotal":
        return RHBInterface.updateRhbExamPlanItemTotal(this as any, e.params);

      case "updateRhbExamPlanItem":
        return RHBInterface.updateRhbExamPlanItem(this as any, e.params as any);

      case "getRhbExamPlan":
        return RHBInterface.getRhbExamPlan(this as any, e.params);

      case "clearRhbExamPlan":
        return RHBInterface.clearRhbExamPlan(this as any, e.params);

      case "getRhbTreatment":
        return RHBInterface.getRhbTreatment(this as any, e.params);

      case "clearRhbTreatment":
        return RHBInterface.clearRhbTreatment(this as any, e.params);

      case "updateRhbTreatmentPlan":
        return RHBInterface.updateRhbTreatmentPlan(this as any, e.params);

      case "getRhbActionLog":
        return RHBInterface.getRhbActionLog(this as any, e.params);

      case "getRhbHistory":
        return RHBInterface.getRhbHistory(this as any, e.params);

      case "clearRhbHistory":
        return RHBInterface.clearRhbHistory(this as any, e.params);

      case "selectRehabHistory":
        return RHBInterface.selectRehabHistory(this as any, e.params);

      case "deleteRhbOrderItem":
        return RHBInterface.deleteRhbOrderItem(this as any, e.params);

      case "deleteRhbPlanItem":
        return RHBInterface.deleteRhbPlanItem(this as any, e.params);

      case "updateRhbTreatmentOrder":
        return RHBInterface.updateRhbTreatmentOrder(this as any, e.params);

      case "updateRhbOrderBillItem":
        return RHBInterface.updateRhbOrderBillItem(this as any, e.params);

      case "getRehabDeviceSlot":
        return RHBInterface.getRehabDeviceSlot(this as any, e.params);

      case "makeAppointmentRhbTreatment":
        return RHBInterface.makeAppointmentRhbTreatment(this as any, e.params);

      case "getRhbAppointment":
        return RHBInterface.getRhbAppointment(this as any, e.params);

      case "selectRehabCombineAppointment":
        return RHBInterface.selectRehabCombineAppointment(this as any, e.params);

      case "printRhbBookingForm":
        return RHBInterface.printRhbBookingForm(this as any, e.params);

      case "printRhbPTCertificateForm":
        return RHBInterface.printRhbPTCertificateForm(this as any, e.params);

      case "putArriveTRTOrder":
        return TECI.putArriveTRTOrder(this as any, e.params);

      case "getTECSession":
        return TECI.getTECSession(this as any, e.params);

      case "getListMedAdminRecord":
        return TPDI.getListMedAdminRecord(this as any, e.params);

      case "postCreateMedAdminRecord":
        return TPDI.postCreateMedAdminRecord(this as any, e.params);

      case "putUpdateMedAdminRecord":
        return TPDI.putUpdateMedAdminRecord(this as any, e.params);

      case "putMedAdminRecord":
        return TPDI.putMedAdminRecord(this as any, e.params);

      case "putDrugOrderItemIdAdminDivision":
        return TPDI.putDrugOrderItemIdAdminDivision(this as any, e.params);

      case "postMedAdminRecord":
        return TPDI.postMedAdminRecord(this as any, e.params);

      case "getPrintMedRecord":
        return TPDI.getPrintMedRecord(this as any, e.params);

      case "getDrugOrderItemForMedReconcile":
        return TPDI.getDrugOrderItemForMedReconcile(this as any, e.params);

      case "tpdService":
        return TPDI.tpdService(this as any, e.params);

      case "getTreatmentOrder":
        return TRTI.getTreatmentOrder(this as any, e.params);

      case "getTreatmentOrderPerformer":
        return TRTI.getTreatmentOrderPerformer(this as any, e.params);

      case "getTreatment":
        return TRTI.getTreatment(this as any, e.params);

      case "postTreatmentOrderEstimate":
        return TRTI.postTreatmentOrderEstimate(this as any, e.params);

      case "postTreatmentOrder":
        return TRTI.postTreatmentOrder(this as any, e.params);

      case "putTreatmentOrderEncounterArrive":
        return TRTI.putTreatmentOrderEncounterArrive(this as any, e.params);

      case "getUserPermission":
        return UserI.getUserPermission(this as any, e.params);

      case "getUserTokenize":
        return UserI.getUserTokenize(this as any, e.params);

      case "getUserTokenizeLicense":
        return UserI.getUserTokenizeLicense(this as any, e.params);

      case "getUserDetail":
        return UserI.getUserDetail(this as any, e.params);

      case "postUserLogin":
        return UserI.postUserLogin(this as any, e.params);

      case "getUserEmployee":
        return UserI.getUserEmployee(this as any, e.params);

      case "getUsers":
        return UserI.getUsers(this as any, e.params);

      case "getUserProfile":
        return UserI.getUserProfile(this as any, e.params);

      case "updateUserProfile":
        return UserI.updateUserProfile(this as any, e.params);

      case "updateUserEmployee":
        return UserI.updateUserEmployee(this as any, e.params);

      case "updateUserAccount":
        return UserI.updateUserAccount(this as any, e.params);

      case "getUserAccount":
        return UserI.getUserAccount(this as any, e.params);

      case "getUserPosition":
        return UserI.getUserPosition(this as any, e.params);

      case "getUserWithPatient":
        return UserI.getUserWithPatient(this as any, e.params);

      case "postUserSetPassword":
        return UserI.postUserSetPassword(this as any, e.params);

      case "getLocation":
        return CoreI.getLocation(this as any, e.params); // proxy to getDivision

      case "getDashboardAppointment":
        return PRXI.getDashboardAppointment(this as any, e.params);

      // Ishealth-v3 port into CUDent (vise versa)
      case "getPatientList":
        return PatientSearchCUInterface.getPatientList(this as any, e.params);

      case "getNatinalities":
        return PatientSearchCUInterface.getNatinalities(this as any, e.params);

      case "choiceNationalities":
        return PatientSearchCUInterface.choiceNationalities(this as any, e.params);

      case "getPatientOldName":
        return PatientSearchCUInterface.getPatientOldName(this as any, e.params);

      case "getPatientByHN":
        return PatientSearchCUInterface.getPatientByHN(this as any, e.params);

      case "searchPatients":
        return PatientSearchCUInterface.searchPatients(this as any, e.params);

      case "loadPatientOldName":
        return PatientSearchCUInterface.loadPatientOldName(this as any, e.params);

      case "SearchStaff":
        return StaffSettingI.SearchStaff(this as any, e.params);

      case "SettingStaff":
        return StaffSettingI.SettingStaff(this as any, e.params);

      case "SettingDivision":
        return StaffSettingI.SettingDivision(this as any, e.params);

      // ----- Dental Diagram
      case "AddLocation":
        DentalRecordI.AddLocation(this as any, e.params);
        return;
      case "ToggleLocation":
        DentalRecordI.ToggleLocation(this as any, e.params);
        return;

      case "apiToken":
        return;

      case "HandleSelect":
        return SetPatientI.HandleSelect(this as any, e.params);

      case "HandleGetPatientOldName":
        return SetPatientI.HandleGetPatientOldName(this as any, e.params);

      case "GetHealthMemberSegment":
        return HealthMemberI.GetHealthMemberSegment(this as any, e.params);

      case "SelectSegmentGroup":
        return HealthMemberI.SelectSegmentGroup(this as any, e.params);

      case "SelectPatientSegment":
        return HealthMemberI.SelectPatientSegment(this as any, e.params);

      // ----- PHVInterface
      case "PrintEMRSummaryForm":
        return PHVInterface.PrintEMRSummaryForm(this as any, e.params);

      case "PrintDischargeSummaryForm":
        return PHVInterface.PrintDischargeSummaryForm(this as any, e.params);

      case "PrintMedicalNoteOrderSummary":
        return PHVInterface.PrintMedicalNoteOrderSummary(this, e.params);

      // ----- ANE
      case "GetAnesVitalSign":
        return ANEInterface.GetAnesVitalSign(this as any, e.params);

      // ----- USERInterface
      case "HandleUploadTemplateExcel":
        return USERInterface.HandleUploadTemplateExcel(this as any, e.params);

      // ----- REGInterface
      case "UpdateEncounterDetail":
        return REGInterface.UpdateEncounterDetail(this as any, e.params);

      case "HandleCreateBuyerEncounter":
        return REGInterface.HandleCreateBuyerEncounter(this as any, e.params);

      default:
        console.log("-- Unhandled case e:", e);
      // let testExhausitve: never = e;
    }
    console.error("-- Unhandled case e:", e);
  };
}
